function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRequire.register("eZpnS", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("6r15D"), import.meta.url).toString();

});

parcelRequire.register("8NNKi", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("iI8az"), import.meta.url).toString();

});

parcelRequire.register("k5z4A", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("18Bji"), import.meta.url).toString();

});

parcelRequire.register("flovY", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("9YlsY"), import.meta.url).toString();

});

parcelRequire.register("5AxGM", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("f77RV"), import.meta.url).toString();

});

parcelRequire.register("25c9V", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("jpXoe"), import.meta.url).toString();

});

parcelRequire.register("3e7ho", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("hbNjC"), import.meta.url).toString();

});

parcelRequire.register("cuiEO", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("czTZJ"), import.meta.url).toString();

});

parcelRequire.register("8JYd6", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("iQpQY"), import.meta.url).toString();

});

parcelRequire.register("bmmz0", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("1fZlq"), import.meta.url).toString();

});

parcelRequire.register("5PfYl", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("jsdk0"), import.meta.url).toString();

});

parcelRequire.register("dBUyq", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("7KQy2"), import.meta.url).toString();

});

parcelRequire.register("9o09i", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("1Drnw"), import.meta.url).toString();

});

parcelRequire.register("KwfgD", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("kpAjF"), import.meta.url).toString();

});

parcelRequire.register("47DtA", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("dsQYz"), import.meta.url).toString();

});

parcelRequire.register("dUT0w", function(module, exports) {

$parcel$export(module.exports, "default", () => $a21b2ca73d4a80ca$export$2e2bcd8739ae039);

var $DkdI3 = parcelRequire("DkdI3");
var $a21b2ca73d4a80ca$export$2e2bcd8739ae039 = {
    "samples": (0, $DkdI3.default)["production"] == "" && (0, $DkdI3.default)["samples"] ? true : false,
    "socketProxyUrl": `${(0, $DkdI3.default)["production"]}/`,
    "proxyUrl": `${(0, $DkdI3.default)["production"]}/api`,
    "proxyAppUrl": `${(0, $DkdI3.default)["production"]}/app`,
    "backendUrl": `http://localhost:1997/officeride/api`,
    "livedrivers": `https://api.not.nammaoorutaxi.com/cabs/ridelaterAPIrequests.php`,
    "ride_request_now": `https://api.not.nammaoorutaxi.com/cabs/dispatchrequest.php?notime=1&requestid=`,
    "ridelaterrequests": `https://api.not.nammaoorutaxi.com/cabs/ridelaterAPIrequests.php`,
    "ride_request_now_selective": `https://api.not.nammaoorutaxi.com/cabs/dispatchrequesttodriver.php`,
    "ridelatersolverroutes": `https://nammaoorutaxi.com/vrs/solver/rideshare/solve`,
    "driverlists": `https://api.not.nammaoorutaxi.com/cabs/list/driversdetails.php`,
    "driverapprovedetails": `https://api.not.nammaoorutaxi.com/cabs/manage-default.php?token=fsdfsdfsdfsdfdfs`,
    "driverofficerideapprovedetails": `https://api.not.nammaoorutaxi.com/cabs/manage-officeride.php?token=fsdfsdfsdfsdfdfs`,
    "driveraccountapprovedetails": `https://api.not.nammaoorutaxi.com/cabs/manage-account.php?token=fsdfsdfsdfsdfdfs`,
    "driversbasedetails": `https://api.not.nammaoorutaxi.com/cabs/list/fetchDrivers.php`,
    "mapmatching": `https://nammaoorutaxi.com/livetracking/api/get?id=`,
    "gps_tracking_local": `http://127.0.0.1:1253/gps-tracker/get-historical-data`,
    "gps_tracking": `https://gpstracker.nammaoorutaxi.com/gps/gps-tracker/get-historical-data`,
    "gps_tracking_total": `https://gpstracker.nammaoorutaxi.com/gps/gps-tracker/get-total-data`,
    "createridelaterrequest": `https://api.not.nammaoorutaxi.com/cabs/createridelaterrequest.php`
};

});
parcelRequire.register("DkdI3", function(module, exports) {

$parcel$export(module.exports, "default", () => $076353eda2b1ccde$export$2e2bcd8739ae039);
var $076353eda2b1ccde$export$2e2bcd8739ae039 = {
    "samples": true,
    "production": ""
};

});


parcelRequire.register("5kHsH", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e20889cb0ddb697$export$2e2bcd8739ae039);
const $3e20889cb0ddb697$var$getHeader = (method, isdefault = true)=>{
    if (method != "POST") return {};
    let header = {};
    if (isdefault) {
        header["Content-Type"] = "application/json";
        header["Accept"] = "application/json";
    } else if (isdefault == "formdata") headers["Content-Type"] = "multipart/form-data";
    let x_access_token = localStorage.getItem("x-access-token");
    if (x_access_token == undefined || x_access_token == "") return false;
    header["x-access-token"] = x_access_token;
    return header;
};
var $3e20889cb0ddb697$export$2e2bcd8739ae039 = {
    getHeader: $3e20889cb0ddb697$var$getHeader
};

});

var $9a191a3e04f89406$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"5mtRI":"landingPage.754a515b.js","6r15D":"address_icon.6a4da000.svg","iI8az":"close_icon.9ca90630.png","18Bji":"contact_address_icon.61db59f3.svg","9YlsY":"contact_email_icon.a51be1b5.svg","f77RV":"contact_phone_icon.79cfee7b.svg","jpXoe":"contact_side_icon.659e2df9.png","hbNjC":"email_icon.817ed231.svg","czTZJ":"hamburger_icon.a7ee304b.png","iQpQY":"phone_icon.ecb0a97d.svg","1fZlq":"success_icon.b097ec65.svg","jsdk0":"vm_routes_logo.090c7270.svg","7KQy2":"security.d60ccb91.svg","1Drnw":"https.a72ef8a4.svg","kpAjF":"facebook.354a082e.svg","dsQYz":"linkedIn.5636bdaf.svg","gjuSx":"accessibility_icon.d395dbc9.png","3l4kW":"billing_icon.216038c3.svg","bjvZF":"compilance_icon.08138cd0.svg","3ekcS":"decision_icon.4372df02.svg","3zH03":"driver_app_icon.a0747bf2.svg","5OIhz":"efficiency_icon.4a203cef.svg","1gKNi":"employee_app_icon.f00f471a.svg","4PReN":"employee_icon.1908272d.svg","2kUew":"employee_side_icon_waiting.86d184fa.png","1q2vq":"features_bg_image.1a8e9151.png","fprcg":"platform_icon.7607e887.png","iDUVc":"precision_icon.bb665b41.svg","23lta":"report_icon.3b6b677c.svg","3PlQ6":"risk_icon.11c61fde.svg","jfYm7":"routing_icon.0182b1eb.svg","bGYA3":"safety_icon.b7829a63.svg","bQH9c":"scale_icon.b0aff415.png","kRU90":"schedule_icon.3535f783.svg","9jzKU":"security_icon.26246f0f.svg","ccL4H":"social_icon.02f1fa55.svg","fJlD5":"storage_icon.71b08f3d.png","e7PMu":"studio_icon.2a3639dd.png","a3MHO":"tracking_icon.dc170d94.svg","bA9WP":"transport_icon.3e8d48ed.png","fouWI":"impact_icon.20942fae.png","e7O1C":"dashboard_screenshot.d5216e8e.png","2nw6L":"trip_screenshot.f785d806.png","n53Mb":"client_screenshot.88342127.png","i18wx":"payments_screenshot.7b9c22a0.png","35nX7":"operator_screenshot.06a44004.png","fqGOj":"vendor_screenshot.833ab1be.png","9jgQW":"vehicle_screenshot.0f5308ec.png","d8a3X":"driver_screenshot.e25b4a10.png","1YO4z":"live_tracking_screenshot.addbb557.png","8tQQg":"home_employee.0660dda9.svg","jCHAF":"create_trip_employee.48be5c0b.svg","fCymb":"upcoming_trips_employee.cac64033.svg","5Nm6D":"trip_history_employee.f8ef0703.svg","4shzu":"absent_record_employee.8d3fe3d0.svg","39uJ9":"settings_employee.b1c8410b.svg","e0Ngl":"home_driver.e04f3bdd.svg","k5FBj":"instant_ride_driver.c217fb2e.svg","crY0v":"assigned_trips_driver.87f40a7c.svg","jvtgy":"trip_history_driver.26642697.svg","av3UA":"my_account_driver.48f2a3ea.svg","2Nb6e":"no_show_driver.191bd37d.svg"}'));

var $28326261748b20ba$exports = {};

$28326261748b20ba$exports = new URL((parcelRequire("27Lyk")).resolve("gjuSx"), import.meta.url).toString();



var $eZpnS = parcelRequire("eZpnS");
var $64bf04f7fb3636f8$exports = {};

$64bf04f7fb3636f8$exports = new URL((parcelRequire("27Lyk")).resolve("3l4kW"), import.meta.url).toString();



var $8NNKi = parcelRequire("8NNKi");
var $a3fddfacbf75fd6c$exports = {};

$a3fddfacbf75fd6c$exports = new URL((parcelRequire("27Lyk")).resolve("bjvZF"), import.meta.url).toString();



var $k5z4A = parcelRequire("k5z4A");

var $flovY = parcelRequire("flovY");

var $5AxGM = parcelRequire("5AxGM");

var $25c9V = parcelRequire("25c9V");
var $16f5ea11e4f9aee3$exports = {};

$16f5ea11e4f9aee3$exports = new URL((parcelRequire("27Lyk")).resolve("3ekcS"), import.meta.url).toString();


var $022fa624ac4a6bf9$exports = {};

$022fa624ac4a6bf9$exports = new URL((parcelRequire("27Lyk")).resolve("3zH03"), import.meta.url).toString();


var $f92ef9f37cf923cb$exports = {};

$f92ef9f37cf923cb$exports = new URL((parcelRequire("27Lyk")).resolve("5OIhz"), import.meta.url).toString();



var $3e7ho = parcelRequire("3e7ho");
var $75b852fe863fc161$exports = {};

$75b852fe863fc161$exports = new URL((parcelRequire("27Lyk")).resolve("1gKNi"), import.meta.url).toString();


var $3fad3f5914d0aa88$exports = {};

$3fad3f5914d0aa88$exports = new URL((parcelRequire("27Lyk")).resolve("4PReN"), import.meta.url).toString();


var $8a088e5380f77345$exports = {};

$8a088e5380f77345$exports = new URL((parcelRequire("27Lyk")).resolve("2kUew"), import.meta.url).toString();


var $059849b7da6603c6$exports = {};

$059849b7da6603c6$exports = new URL((parcelRequire("27Lyk")).resolve("1q2vq"), import.meta.url).toString();



var $cuiEO = parcelRequire("cuiEO");

var $8JYd6 = parcelRequire("8JYd6");
var $3446c178285ad0f6$exports = {};

$3446c178285ad0f6$exports = new URL((parcelRequire("27Lyk")).resolve("fprcg"), import.meta.url).toString();


var $0ffaeadf21a031b7$exports = {};

$0ffaeadf21a031b7$exports = new URL((parcelRequire("27Lyk")).resolve("iDUVc"), import.meta.url).toString();


var $b1480166ba9d3d6d$exports = {};

$b1480166ba9d3d6d$exports = new URL((parcelRequire("27Lyk")).resolve("23lta"), import.meta.url).toString();


var $4498c01e9bddc6d6$exports = {};

$4498c01e9bddc6d6$exports = new URL((parcelRequire("27Lyk")).resolve("3PlQ6"), import.meta.url).toString();


var $bd9c3ac91e022899$exports = {};

$bd9c3ac91e022899$exports = new URL((parcelRequire("27Lyk")).resolve("jfYm7"), import.meta.url).toString();


var $2dfb4ebf6b2351a3$exports = {};

$2dfb4ebf6b2351a3$exports = new URL((parcelRequire("27Lyk")).resolve("bGYA3"), import.meta.url).toString();


var $f9f4a74791b36a2a$exports = {};

$f9f4a74791b36a2a$exports = new URL((parcelRequire("27Lyk")).resolve("bQH9c"), import.meta.url).toString();


var $4c2e637e645d74e9$exports = {};

$4c2e637e645d74e9$exports = new URL((parcelRequire("27Lyk")).resolve("kRU90"), import.meta.url).toString();


var $30402a411a8f3b6e$exports = {};

$30402a411a8f3b6e$exports = new URL((parcelRequire("27Lyk")).resolve("9jzKU"), import.meta.url).toString();


var $67b87f2cbecfba18$exports = {};

$67b87f2cbecfba18$exports = new URL((parcelRequire("27Lyk")).resolve("ccL4H"), import.meta.url).toString();


var $bc210e678f5a2281$exports = {};

$bc210e678f5a2281$exports = new URL((parcelRequire("27Lyk")).resolve("fJlD5"), import.meta.url).toString();


var $c091c6a0b9d97cf3$exports = {};

$c091c6a0b9d97cf3$exports = new URL((parcelRequire("27Lyk")).resolve("e7PMu"), import.meta.url).toString();



var $bmmz0 = parcelRequire("bmmz0");
var $1f48efcab23756ad$exports = {};

$1f48efcab23756ad$exports = new URL((parcelRequire("27Lyk")).resolve("a3MHO"), import.meta.url).toString();


var $2b47b7076fe7c659$exports = {};

$2b47b7076fe7c659$exports = new URL((parcelRequire("27Lyk")).resolve("bA9WP"), import.meta.url).toString();



var $5PfYl = parcelRequire("5PfYl");
var $3f1e5e73bb1d8f35$exports = {};

$3f1e5e73bb1d8f35$exports = new URL((parcelRequire("27Lyk")).resolve("fouWI"), import.meta.url).toString();


var $21f54033038d7836$exports = {};

$21f54033038d7836$exports = new URL((parcelRequire("27Lyk")).resolve("e7O1C"), import.meta.url).toString();


var $2f59ba8ab64cba3a$exports = {};

$2f59ba8ab64cba3a$exports = new URL((parcelRequire("27Lyk")).resolve("2nw6L"), import.meta.url).toString();


var $b70333fc00ed3144$exports = {};

$b70333fc00ed3144$exports = new URL((parcelRequire("27Lyk")).resolve("n53Mb"), import.meta.url).toString();


var $345999c5a3f0615b$exports = {};

$345999c5a3f0615b$exports = new URL((parcelRequire("27Lyk")).resolve("i18wx"), import.meta.url).toString();


var $806ba0e73f9a5d90$exports = {};

$806ba0e73f9a5d90$exports = new URL((parcelRequire("27Lyk")).resolve("35nX7"), import.meta.url).toString();


var $f80bf49ee85e2d32$exports = {};

$f80bf49ee85e2d32$exports = new URL((parcelRequire("27Lyk")).resolve("fqGOj"), import.meta.url).toString();


var $bdcba894a1075853$exports = {};

$bdcba894a1075853$exports = new URL((parcelRequire("27Lyk")).resolve("9jgQW"), import.meta.url).toString();


var $0b54781138f0e07e$exports = {};

$0b54781138f0e07e$exports = new URL((parcelRequire("27Lyk")).resolve("d8a3X"), import.meta.url).toString();


var $bdd3e294f5e0c8d1$exports = {};

$bdd3e294f5e0c8d1$exports = new URL((parcelRequire("27Lyk")).resolve("1YO4z"), import.meta.url).toString();


var $59ab84433bd2ed88$exports = {};

$59ab84433bd2ed88$exports = new URL((parcelRequire("27Lyk")).resolve("8tQQg"), import.meta.url).toString();


var $b36500abb531d545$exports = {};

$b36500abb531d545$exports = new URL((parcelRequire("27Lyk")).resolve("jCHAF"), import.meta.url).toString();


var $431456f3100abfe4$exports = {};

$431456f3100abfe4$exports = new URL((parcelRequire("27Lyk")).resolve("fCymb"), import.meta.url).toString();


var $917b7e540a6c689c$exports = {};

$917b7e540a6c689c$exports = new URL((parcelRequire("27Lyk")).resolve("5Nm6D"), import.meta.url).toString();


var $a1492487b6416c40$exports = {};

$a1492487b6416c40$exports = new URL((parcelRequire("27Lyk")).resolve("4shzu"), import.meta.url).toString();


var $18814ebf0ccd3ba8$exports = {};

$18814ebf0ccd3ba8$exports = new URL((parcelRequire("27Lyk")).resolve("39uJ9"), import.meta.url).toString();


var $796e53c0c1c8bbed$exports = {};

$796e53c0c1c8bbed$exports = new URL((parcelRequire("27Lyk")).resolve("e0Ngl"), import.meta.url).toString();


var $edf69615f0452b2d$exports = {};

$edf69615f0452b2d$exports = new URL((parcelRequire("27Lyk")).resolve("k5FBj"), import.meta.url).toString();


var $687063693d14a4c7$exports = {};

$687063693d14a4c7$exports = new URL((parcelRequire("27Lyk")).resolve("crY0v"), import.meta.url).toString();


var $da1e4ef46e934019$exports = {};

$da1e4ef46e934019$exports = new URL((parcelRequire("27Lyk")).resolve("jvtgy"), import.meta.url).toString();


var $d23db20b988491a9$exports = {};

$d23db20b988491a9$exports = new URL((parcelRequire("27Lyk")).resolve("av3UA"), import.meta.url).toString();


var $aa00ee01ce7121c3$exports = {};

$aa00ee01ce7121c3$exports = new URL((parcelRequire("27Lyk")).resolve("2Nb6e"), import.meta.url).toString();



var $dBUyq = parcelRequire("dBUyq");

var $9o09i = parcelRequire("9o09i");

var $KwfgD = parcelRequire("KwfgD");

var $47DtA = parcelRequire("47DtA");

var $dUT0w = parcelRequire("dUT0w");

var $DkdI3 = parcelRequire("DkdI3");
parcelRequire("5kHsH");
/*!
 * Glide.js v3.7.1
 * (c) 2013-2024 Jędrzej Chałubek (https://github.com/jedrzejchalubek/)
 * Released under the MIT License.
 */ function $e4cadc049684851d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e4cadc049684851d$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e4cadc049684851d$var$ownKeys(Object(source), true).forEach(function(key) {
            $e4cadc049684851d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e4cadc049684851d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e4cadc049684851d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $e4cadc049684851d$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $e4cadc049684851d$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $e4cadc049684851d$var$_typeof(obj);
}
function $e4cadc049684851d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e4cadc049684851d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e4cadc049684851d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e4cadc049684851d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e4cadc049684851d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $e4cadc049684851d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e4cadc049684851d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $e4cadc049684851d$var$_setPrototypeOf(subClass, superClass);
}
function $e4cadc049684851d$var$_getPrototypeOf(o) {
    $e4cadc049684851d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e4cadc049684851d$var$_getPrototypeOf(o);
}
function $e4cadc049684851d$var$_setPrototypeOf(o, p) {
    $e4cadc049684851d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e4cadc049684851d$var$_setPrototypeOf(o, p);
}
function $e4cadc049684851d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e4cadc049684851d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e4cadc049684851d$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e4cadc049684851d$var$_assertThisInitialized(self);
}
function $e4cadc049684851d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e4cadc049684851d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $e4cadc049684851d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e4cadc049684851d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e4cadc049684851d$var$_possibleConstructorReturn(this, result);
    };
}
function $e4cadc049684851d$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $e4cadc049684851d$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $e4cadc049684851d$var$_get() {
    if (typeof Reflect !== "undefined" && Reflect.get) $e4cadc049684851d$var$_get = Reflect.get;
    else $e4cadc049684851d$var$_get = function _get(target, property, receiver) {
        var base = $e4cadc049684851d$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(arguments.length < 3 ? target : receiver);
        return desc.value;
    };
    return $e4cadc049684851d$var$_get.apply(this, arguments);
}
var $e4cadc049684851d$var$defaults = {
    /**
   * Type of the movement.
   *
   * Available types:
   * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
   * `carousel` - Changes slides without starting over when it reaches the first or last slide.
   *
   * @type {String}
   */ type: "slider",
    /**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */ startAt: 0,
    /**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */ perView: 1,
    /**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */ focusAt: 0,
    /**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */ gap: 10,
    /**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */ autoplay: false,
    /**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */ hoverpause: true,
    /**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */ keyboard: true,
    /**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only with `slider` type and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */ bound: false,
    /**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */ swipeThreshold: 80,
    /**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */ dragThreshold: 120,
    /**
   * A number of slides moved on single swipe.
   *
   * Available types:
   * `` - Moves slider by one slide per swipe
   * `|` - Moves slider between views per swipe (number of slides defined in `perView` options)
   *
   * @type {String}
   */ perSwipe: "",
    /**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */ touchRatio: 0.5,
    /**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */ touchAngle: 45,
    /**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */ animationDuration: 400,
    /**
   * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
   *
   * @type {Boolean}
   */ rewind: true,
    /**
   * Duration of the rewinding animation of the `slider` type in milliseconds.
   *
   * @type {Number}
   */ rewindDuration: 800,
    /**
   * Easing function for the animation.
   *
   * @type {String}
   */ animationTimingFunc: "cubic-bezier(.165, .840, .440, 1)",
    /**
   * Wait for the animation to finish until the next user input can be processed
   *
   * @type {boolean}
   */ waitForTransition: true,
    /**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */ throttle: 10,
    /**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */ direction: "ltr",
    /**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */ peek: 0,
    /**
   * Defines how many clones of current viewport will be generated.
   *
   * @type {Number}
   */ cloningRatio: 1,
    /**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */ breakpoints: {},
    /**
   * Collection of internally used HTML classes.
   *
   * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
   * @type {Object}
   */ classes: {
        swipeable: "glide--swipeable",
        dragging: "glide--dragging",
        direction: {
            ltr: "glide--ltr",
            rtl: "glide--rtl"
        },
        type: {
            slider: "glide--slider",
            carousel: "glide--carousel"
        },
        slide: {
            clone: "glide__slide--clone",
            active: "glide__slide--active"
        },
        arrow: {
            disabled: "glide__arrow--disabled"
        },
        nav: {
            active: "glide__bullet--active"
        }
    }
};
/**
 * Outputs warning message to the bowser console.
 *
 * @param  {String} msg
 * @return {Void}
 */ function $e4cadc049684851d$var$warn(msg) {
    console.error("[Glide warn]: ".concat(msg));
}
/**
 * Converts value entered as number
 * or string to integer value.
 *
 * @param {String} value
 * @returns {Number}
 */ function $e4cadc049684851d$var$toInt(value) {
    return parseInt(value);
}
/**
 * Converts value entered as number
 * or string to flat value.
 *
 * @param {String} value
 * @returns {Number}
 */ function $e4cadc049684851d$var$toFloat(value) {
    return parseFloat(value);
}
/**
 * Indicates whether the specified value is a string.
 *
 * @param  {*}   value
 * @return {Boolean}
 */ function $e4cadc049684851d$var$isString(value) {
    return typeof value === "string";
}
/**
 * Indicates whether the specified value is an object.
 *
 * @param  {*} value
 * @return {Boolean}
 *
 * @see https://github.com/jashkenas/underscore
 */ function $e4cadc049684851d$var$isObject(value) {
    var type = $e4cadc049684851d$var$_typeof(value);
    return type === "function" || type === "object" && !!value; // eslint-disable-line no-mixed-operators
}
/**
 * Indicates whether the specified value is a function.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function $e4cadc049684851d$var$isFunction(value) {
    return typeof value === "function";
}
/**
 * Indicates whether the specified value is undefined.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function $e4cadc049684851d$var$isUndefined(value) {
    return typeof value === "undefined";
}
/**
 * Indicates whether the specified value is an array.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function $e4cadc049684851d$var$isArray(value) {
    return value.constructor === Array;
}
/**
 * Creates and initializes specified collection of extensions.
 * Each extension receives access to instance of glide and rest of components.
 *
 * @param {Object} glide
 * @param {Object} extensions
 *
 * @returns {Object}
 */ function $e4cadc049684851d$var$mount(glide, extensions, events) {
    var components = {};
    for(var name in extensions)if ($e4cadc049684851d$var$isFunction(extensions[name])) components[name] = extensions[name](glide, components, events);
    else $e4cadc049684851d$var$warn("Extension must be a function");
    for(var _name in components)if ($e4cadc049684851d$var$isFunction(components[_name].mount)) components[_name].mount();
    return components;
}
/**
 * Defines getter and setter property on the specified object.
 *
 * @param  {Object} obj         Object where property has to be defined.
 * @param  {String} prop        Name of the defined property.
 * @param  {Object} definition  Get and set definitions for the property.
 * @return {Void}
 */ function $e4cadc049684851d$var$define(obj, prop, definition) {
    Object.defineProperty(obj, prop, definition);
}
/**
 * Sorts aphabetically object keys.
 *
 * @param  {Object} obj
 * @return {Object}
 */ function $e4cadc049684851d$var$sortKeys(obj) {
    return Object.keys(obj).sort().reduce(function(r, k) {
        r[k] = obj[k];
        return r[k], r;
    }, {});
}
/**
 * Merges passed settings object with default options.
 *
 * @param  {Object} defaults
 * @param  {Object} settings
 * @return {Object}
 */ function $e4cadc049684851d$var$mergeOptions(defaults, settings) {
    var options = Object.assign({}, defaults, settings); // `Object.assign` do not deeply merge objects, so we
    // have to do it manually for every nested object
    // in options. Although it does not look smart,
    // it's smaller and faster than some fancy
    // merging deep-merge algorithm script.
    if (settings.hasOwnProperty("classes")) {
        options.classes = Object.assign({}, defaults.classes, settings.classes);
        var properties = [
            "direction",
            "type",
            "slide",
            "arrow",
            "nav"
        ];
        properties.forEach(function(property) {
            if (settings.classes.hasOwnProperty(property)) options.classes[property] = $e4cadc049684851d$var$_objectSpread2($e4cadc049684851d$var$_objectSpread2({}, defaults.classes[property]), settings.classes[property]);
        });
    }
    if (settings.hasOwnProperty("breakpoints")) options.breakpoints = Object.assign({}, defaults.breakpoints, settings.breakpoints);
    return options;
}
var $e4cadc049684851d$var$EventsBus = /*#__PURE__*/ function() {
    /**
   * Construct a EventBus instance.
   *
   * @param {Object} events
   */ function EventsBus() {
        var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $e4cadc049684851d$var$_classCallCheck(this, EventsBus);
        this.events = events;
        this.hop = events.hasOwnProperty;
    }
    /**
   * Adds listener to the specifed event.
   *
   * @param {String|Array} event
   * @param {Function} handler
   */ $e4cadc049684851d$var$_createClass(EventsBus, [
        {
            key: "on",
            value: function on(event, handler) {
                if ($e4cadc049684851d$var$isArray(event)) {
                    for(var i = 0; i < event.length; i++)this.on(event[i], handler);
                    return;
                } // Create the event's object if not yet created
                if (!this.hop.call(this.events, event)) this.events[event] = [];
                 // Add the handler to queue
                var index = this.events[event].push(handler) - 1; // Provide handle back for removal of event
                return {
                    remove: function remove() {
                        delete this.events[event][index];
                    }
                };
            }
        },
        {
            key: "emit",
            value: function emit(event, context) {
                if ($e4cadc049684851d$var$isArray(event)) {
                    for(var i = 0; i < event.length; i++)this.emit(event[i], context);
                    return;
                } // If the event doesn't exist, or there's no handlers in queue, just leave
                if (!this.hop.call(this.events, event)) return;
                 // Cycle through events queue, fire!
                this.events[event].forEach(function(item) {
                    item(context || {});
                });
            }
        }
    ]);
    return EventsBus;
}();
var $e4cadc049684851d$var$Glide$1 = /*#__PURE__*/ function() {
    /**
   * Construct glide.
   *
   * @param  {String} selector
   * @param  {Object} options
   */ function Glide(selector) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $e4cadc049684851d$var$_classCallCheck(this, Glide);
        this._c = {};
        this._t = [];
        this._e = new $e4cadc049684851d$var$EventsBus();
        this.disabled = false;
        this.selector = selector;
        this.settings = $e4cadc049684851d$var$mergeOptions($e4cadc049684851d$var$defaults, options);
        this.index = this.settings.startAt;
    }
    /**
   * Initializes glide.
   *
   * @param {Object} extensions Collection of extensions to initialize.
   * @return {Glide}
   */ $e4cadc049684851d$var$_createClass(Glide, [
        {
            key: "mount",
            value: function mount$1() {
                var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                this._e.emit("mount.before");
                if ($e4cadc049684851d$var$isObject(extensions)) this._c = $e4cadc049684851d$var$mount(this, extensions, this._e);
                else $e4cadc049684851d$var$warn("You need to provide a object on `mount()`");
                this._e.emit("mount.after");
                return this;
            }
        },
        {
            key: "mutate",
            value: function mutate() {
                var transformers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                if ($e4cadc049684851d$var$isArray(transformers)) this._t = transformers;
                else $e4cadc049684851d$var$warn("You need to provide a array on `mutate()`");
                return this;
            }
        },
        {
            key: "update",
            value: function update() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                this.settings = $e4cadc049684851d$var$mergeOptions(this.settings, settings);
                if (settings.hasOwnProperty("startAt")) this.index = settings.startAt;
                this._e.emit("update");
                return this;
            }
        },
        {
            key: "go",
            value: function go(pattern) {
                this._c.Run.make(pattern);
                return this;
            }
        },
        {
            key: "move",
            value: function move(distance) {
                this._c.Transition.disable();
                this._c.Move.make(distance);
                return this;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this._e.emit("destroy");
                return this;
            }
        },
        {
            key: "play",
            value: function play() {
                var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                if (interval) this.settings.autoplay = interval;
                this._e.emit("play");
                return this;
            }
        },
        {
            key: "pause",
            value: function pause() {
                this._e.emit("pause");
                return this;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.disabled = true;
                return this;
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.disabled = false;
                return this;
            }
        },
        {
            key: "on",
            value: function on(event, handler) {
                this._e.on(event, handler);
                return this;
            }
        },
        {
            key: "isType",
            value: function isType(name) {
                return this.settings.type === name;
            }
        },
        {
            key: "settings",
            get: function get() {
                return this._o;
            },
            set: function set(o) {
                if ($e4cadc049684851d$var$isObject(o)) this._o = o;
                else $e4cadc049684851d$var$warn("Options must be an `object` instance.");
            }
        },
        {
            key: "index",
            get: function get() {
                return this._i;
            },
            set: function set(i) {
                this._i = $e4cadc049684851d$var$toInt(i);
            }
        },
        {
            key: "type",
            get: function get() {
                return this.settings.type;
            }
        },
        {
            key: "disabled",
            get: function get() {
                return this._d;
            },
            set: function set(status) {
                this._d = !!status;
            }
        }
    ]);
    return Glide;
}();
function $e4cadc049684851d$var$Run(Glide, Components, Events) {
    var Run = {
        /**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */ mount: function mount() {
            this._o = false;
        },
        /**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */ make: function make(move) {
            var _this = this;
            if (!Glide.disabled) {
                !Glide.settings.waitForTransition || Glide.disable();
                this.move = move;
                Events.emit("run.before", this.move);
                this.calculate();
                Events.emit("run", this.move);
                Components.Transition.after(function() {
                    if (_this.isStart()) Events.emit("run.start", _this.move);
                    if (_this.isEnd()) Events.emit("run.end", _this.move);
                    if (_this.isOffset()) {
                        _this._o = false;
                        Events.emit("run.offset", _this.move);
                    }
                    Events.emit("run.after", _this.move);
                    Glide.enable();
                });
            }
        },
        /**
     * Calculates current index based on defined move.
     *
     * @return {Number|Undefined}
     */ calculate: function calculate() {
            var move = this.move, length = this.length;
            var steps = move.steps, direction = move.direction; // By default assume that size of view is equal to one slide
            var viewSize = 1; // While direction is `=` we want jump to
            // a specified index described in steps.
            if (direction === "=") {
                // Check if bound is true, 
                // as we want to avoid whitespaces.
                if (Glide.settings.bound && $e4cadc049684851d$var$toInt(steps) > length) {
                    Glide.index = length;
                    return;
                }
                Glide.index = steps;
                return;
            } // When pattern is equal to `>>` we want
            // fast forward to the last slide.
            if (direction === ">" && steps === ">") {
                Glide.index = length;
                return;
            } // When pattern is equal to `<<` we want
            // fast forward to the first slide.
            if (direction === "<" && steps === "<") {
                Glide.index = 0;
                return;
            } // pagination movement
            if (direction === "|") viewSize = Glide.settings.perView || 1;
             // we are moving forward
            if (direction === ">" || direction === "|" && steps === ">") {
                var index = calculateForwardIndex(viewSize);
                if (index > length) this._o = true;
                Glide.index = normalizeForwardIndex(index, viewSize);
                return;
            } // we are moving backward
            if (direction === "<" || direction === "|" && steps === "<") {
                var _index = calculateBackwardIndex(viewSize);
                if (_index < 0) this._o = true;
                Glide.index = normalizeBackwardIndex(_index, viewSize);
                return;
            }
            $e4cadc049684851d$var$warn("Invalid direction pattern [".concat(direction).concat(steps, "] has been used"));
        },
        /**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */ isStart: function isStart() {
            return Glide.index <= 0;
        },
        /**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */ isEnd: function isEnd() {
            return Glide.index >= this.length;
        },
        /**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */ isOffset: function isOffset() {
            var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            if (!direction) return this._o;
            if (!this._o) return false;
             // did we view to the right?
            if (direction === "|>") return this.move.direction === "|" && this.move.steps === ">";
             // did we view to the left?
            if (direction === "|<") return this.move.direction === "|" && this.move.steps === "<";
            return this.move.direction === direction;
        },
        /**
     * Checks if bound mode is active
     *
     * @return {Boolean}
     */ isBound: function isBound() {
            return Glide.isType("slider") && Glide.settings.focusAt !== "center" && Glide.settings.bound;
        }
    };
    /**
   * Returns index value to move forward/to the right
   *
   * @param viewSize
   * @returns {Number}
   */ function calculateForwardIndex(viewSize) {
        var index = Glide.index;
        if (Glide.isType("carousel")) return index + viewSize;
        return index + (viewSize - index % viewSize);
    }
    /**
   * Normalizes the given forward index based on glide settings, preventing it to exceed certain boundaries
   *
   * @param index
   * @param length
   * @param viewSize
   * @returns {Number}
   */ function normalizeForwardIndex(index, viewSize) {
        var length = Run.length;
        if (index <= length) return index;
        if (Glide.isType("carousel")) return index - (length + 1);
        if (Glide.settings.rewind) {
            // bound does funny things with the length, therefor we have to be certain
            // that we are on the last possible index value given by bound
            if (Run.isBound() && !Run.isEnd()) return length;
            return 0;
        }
        if (Run.isBound()) return length;
        return Math.floor(length / viewSize) * viewSize;
    }
    /**
   * Calculates index value to move backward/to the left
   *
   * @param viewSize
   * @returns {Number}
   */ function calculateBackwardIndex(viewSize) {
        var index = Glide.index;
        if (Glide.isType("carousel")) return index - viewSize;
         // ensure our back navigation results in the same index as a forward navigation
        // to experience a homogeneous paging
        var view = Math.ceil(index / viewSize);
        return (view - 1) * viewSize;
    }
    /**
   * Normalizes the given backward index based on glide settings, preventing it to exceed certain boundaries
   *
   * @param index
   * @param length
   * @param viewSize
   * @returns {*}
   */ function normalizeBackwardIndex(index, viewSize) {
        var length = Run.length;
        if (index >= 0) return index;
        if (Glide.isType("carousel")) return index + (length + 1);
        if (Glide.settings.rewind) {
            // bound does funny things with the length, therefor we have to be certain
            // that we are on first possible index value before we to rewind to the length given by bound
            if (Run.isBound() && Run.isStart()) return length;
            return Math.floor(length / viewSize) * viewSize;
        }
        return 0;
    }
    $e4cadc049684851d$var$define(Run, "move", {
        /**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */ get: function get() {
            return this._m;
        },
        /**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */ set: function set(value) {
            var step = value.substr(1);
            this._m = {
                direction: value.substr(0, 1),
                steps: step ? $e4cadc049684851d$var$toInt(step) ? $e4cadc049684851d$var$toInt(step) : step : 0
            };
        }
    });
    $e4cadc049684851d$var$define(Run, "length", {
        /**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */ get: function get() {
            var settings = Glide.settings;
            var length = Components.Html.slides.length; // If the `bound` option is active, a maximum running distance should be
            // reduced by `perView` and `focusAt` settings. Running distance
            // should end before creating an empty space after instance.
            if (this.isBound()) return length - 1 - ($e4cadc049684851d$var$toInt(settings.perView) - 1) + $e4cadc049684851d$var$toInt(settings.focusAt);
            return length - 1;
        }
    });
    $e4cadc049684851d$var$define(Run, "offset", {
        /**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */ get: function get() {
            return this._o;
        }
    });
    return Run;
}
/**
 * Returns a current time.
 *
 * @return {Number}
 */ function $e4cadc049684851d$var$now() {
    return new Date().getTime();
}
/**
 * Returns a function, that, when invoked, will only be triggered
 * at most once during a given window of time.
 *
 * @param {Function} func
 * @param {Number} wait
 * @param {Object=} options
 * @return {Function}
 *
 * @see https://github.com/jashkenas/underscore
 */ function $e4cadc049684851d$var$throttle(func, wait) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var timeout, context, args, result;
    var previous = 0;
    var later = function later() {
        previous = options.leading === false ? 0 : $e4cadc049684851d$var$now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function throttled() {
        var at = $e4cadc049684851d$var$now();
        if (!previous && options.leading === false) previous = at;
        var remaining = wait - (at - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = at;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
}
var $e4cadc049684851d$var$MARGIN_TYPE = {
    ltr: [
        "marginLeft",
        "marginRight"
    ],
    rtl: [
        "marginRight",
        "marginLeft"
    ]
};
function $e4cadc049684851d$var$Gaps(Glide, Components, Events) {
    var Gaps = {
        /**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */ apply: function apply(slides) {
            for(var i = 0, len = slides.length; i < len; i++){
                var style = slides[i].style;
                var direction = Components.Direction.value;
                if (i !== 0) style[$e4cadc049684851d$var$MARGIN_TYPE[direction][0]] = "".concat(this.value / 2, "px");
                else style[$e4cadc049684851d$var$MARGIN_TYPE[direction][0]] = "";
                if (i !== slides.length - 1) style[$e4cadc049684851d$var$MARGIN_TYPE[direction][1]] = "".concat(this.value / 2, "px");
                else style[$e4cadc049684851d$var$MARGIN_TYPE[direction][1]] = "";
            }
        },
        /**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
    */ remove: function remove(slides) {
            for(var i = 0, len = slides.length; i < len; i++){
                var style = slides[i].style;
                style.marginLeft = "";
                style.marginRight = "";
            }
        }
    };
    $e4cadc049684851d$var$define(Gaps, "value", {
        /**
     * Gets value of the gap.
     *
     * @returns {Number}
     */ get: function get() {
            return $e4cadc049684851d$var$toInt(Glide.settings.gap);
        }
    });
    $e4cadc049684851d$var$define(Gaps, "grow", {
        /**
     * Gets additional dimensions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */ get: function get() {
            return Gaps.value * Components.Sizes.length;
        }
    });
    $e4cadc049684851d$var$define(Gaps, "reductor", {
        /**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */ get: function get() {
            var perView = Glide.settings.perView;
            return Gaps.value * (perView - 1) / perView;
        }
    });
    /**
   * Apply calculated gaps:
   * - after building, so slides (including clones) will receive proper margins
   * - on updating via API, to recalculate gaps with new options
   */ Events.on([
        "build.after",
        "update"
    ], $e4cadc049684851d$var$throttle(function() {
        Gaps.apply(Components.Html.wrapper.children);
    }, 30));
    /**
   * Remove gaps:
   * - on destroying to bring markup to its inital state
   */ Events.on("destroy", function() {
        Gaps.remove(Components.Html.wrapper.children);
    });
    return Gaps;
}
/**
 * Finds siblings nodes of the passed node.
 *
 * @param  {Element} node
 * @return {Array}
 */ function $e4cadc049684851d$var$siblings(node) {
    if (node && node.parentNode) {
        var n = node.parentNode.firstChild;
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== node) matched.push(n);
        return matched;
    }
    return [];
}
/**
 * Coerces a NodeList to an Array.
 *
 * @param  {NodeList} nodeList
 * @return {Array}
 */ function $e4cadc049684851d$var$toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
}
var $e4cadc049684851d$var$TRACK_SELECTOR = '[data-glide-el="track"]';
function $e4cadc049684851d$var$Html(Glide, Components, Events) {
    var Html = {
        /**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */ mount: function mount() {
            this.root = Glide.selector;
            this.track = this.root.querySelector($e4cadc049684851d$var$TRACK_SELECTOR);
            this.collectSlides();
        },
        /**
     * Collect slides
     */ collectSlides: function collectSlides() {
            this.slides = $e4cadc049684851d$var$toArray(this.wrapper.children).filter(function(slide) {
                return !slide.classList.contains(Glide.settings.classes.slide.clone);
            });
        }
    };
    $e4cadc049684851d$var$define(Html, "root", {
        /**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */ get: function get() {
            return Html._r;
        },
        /**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */ set: function set(r) {
            if ($e4cadc049684851d$var$isString(r)) r = document.querySelector(r);
            if (r !== null) Html._r = r;
            else $e4cadc049684851d$var$warn("Root element must be a existing Html node");
        }
    });
    $e4cadc049684851d$var$define(Html, "track", {
        /**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */ get: function get() {
            return Html._t;
        },
        /**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */ set: function set(t) {
            Html._t = t;
        }
    });
    $e4cadc049684851d$var$define(Html, "wrapper", {
        /**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */ get: function get() {
            return Html.track.children[0];
        }
    });
    /**
   * Add/remove/reorder dynamic slides
   */ Events.on("update", function() {
        Html.collectSlides();
    });
    return Html;
}
function $e4cadc049684851d$var$Peek(Glide, Components, Events) {
    var Peek = {
        /**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */ mount: function mount() {
            this.value = Glide.settings.peek;
        }
    };
    $e4cadc049684851d$var$define(Peek, "value", {
        /**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */ get: function get() {
            return Peek._v;
        },
        /**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */ set: function set(value) {
            if ($e4cadc049684851d$var$isObject(value)) {
                value.before = $e4cadc049684851d$var$toInt(value.before);
                value.after = $e4cadc049684851d$var$toInt(value.after);
            } else value = $e4cadc049684851d$var$toInt(value);
            Peek._v = value;
        }
    });
    $e4cadc049684851d$var$define(Peek, "reductor", {
        /**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */ get: function get() {
            var value = Peek.value;
            var perView = Glide.settings.perView;
            if ($e4cadc049684851d$var$isObject(value)) return value.before / perView + value.after / perView;
            return value * 2 / perView;
        }
    });
    /**
   * Recalculate peeking sizes on:
   * - when resizing window to update to proper percents
   */ Events.on([
        "resize",
        "update"
    ], function() {
        Peek.mount();
    });
    return Peek;
}
function $e4cadc049684851d$var$Move(Glide, Components, Events) {
    var Move = {
        /**
     * Constructs move component.
     *
     * @returns {Void}
     */ mount: function mount() {
            this._o = 0;
        },
        /**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */ make: function make() {
            var _this = this;
            var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            this.offset = offset;
            Events.emit("move", {
                movement: this.value
            });
            Components.Transition.after(function() {
                Events.emit("move.after", {
                    movement: _this.value
                });
            });
        }
    };
    $e4cadc049684851d$var$define(Move, "offset", {
        /**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */ get: function get() {
            return Move._o;
        },
        /**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */ set: function set(value) {
            Move._o = !$e4cadc049684851d$var$isUndefined(value) ? $e4cadc049684851d$var$toInt(value) : 0;
        }
    });
    $e4cadc049684851d$var$define(Move, "translate", {
        /**
     * Gets a raw movement value.
     *
     * @return {Number}
     */ get: function get() {
            return Components.Sizes.slideWidth * Glide.index;
        }
    });
    $e4cadc049684851d$var$define(Move, "value", {
        /**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */ get: function get() {
            var offset = this.offset;
            var translate = this.translate;
            if (Components.Direction.is("rtl")) return translate + offset;
            return translate - offset;
        }
    });
    /**
   * Make movement to proper slide on:
   * - before build, so glide will start at `startAt` index
   * - on each standard run to move to newly calculated index
   */ Events.on([
        "build.before",
        "run"
    ], function() {
        Move.make();
    });
    return Move;
}
function $e4cadc049684851d$var$Sizes(Glide, Components, Events) {
    var Sizes = {
        /**
     * Setups dimensions of slides.
     *
     * @return {Void}
     */ setupSlides: function setupSlides() {
            var width = "".concat(this.slideWidth, "px");
            var slides = Components.Html.slides;
            for(var i = 0; i < slides.length; i++)slides[i].style.width = width;
        },
        /**
     * Setups dimensions of slides wrapper.
     *
     * @return {Void}
     */ setupWrapper: function setupWrapper() {
            Components.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
        },
        /**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */ remove: function remove() {
            var slides = Components.Html.slides;
            for(var i = 0; i < slides.length; i++)slides[i].style.width = "";
            Components.Html.wrapper.style.width = "";
        }
    };
    $e4cadc049684851d$var$define(Sizes, "length", {
        /**
     * Gets count number of the slides.
     *
     * @return {Number}
     */ get: function get() {
            return Components.Html.slides.length;
        }
    });
    $e4cadc049684851d$var$define(Sizes, "width", {
        /**
     * Gets width value of the slider (visible area).
     *
     * @return {Number}
     */ get: function get() {
            return Components.Html.track.offsetWidth;
        }
    });
    $e4cadc049684851d$var$define(Sizes, "wrapperSize", {
        /**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */ get: function get() {
            return Sizes.slideWidth * Sizes.length + Components.Gaps.grow + Components.Clones.grow;
        }
    });
    $e4cadc049684851d$var$define(Sizes, "slideWidth", {
        /**
     * Gets width value of a single slide.
     *
     * @return {Number}
     */ get: function get() {
            return Sizes.width / Glide.settings.perView - Components.Peek.reductor - Components.Gaps.reductor;
        }
    });
    /**
   * Apply calculated glide's dimensions:
   * - before building, so other dimensions (e.g. translate) will be calculated propertly
   * - when resizing window to recalculate sildes dimensions
   * - on updating via API, to calculate dimensions based on new options
   */ Events.on([
        "build.before",
        "resize",
        "update"
    ], function() {
        Sizes.setupSlides();
        Sizes.setupWrapper();
    });
    /**
   * Remove calculated glide's dimensions:
   * - on destoting to bring markup to its inital state
   */ Events.on("destroy", function() {
        Sizes.remove();
    });
    return Sizes;
}
function $e4cadc049684851d$var$Build(Glide, Components, Events) {
    var Build = {
        /**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */ mount: function mount() {
            Events.emit("build.before");
            this.typeClass();
            this.activeClass();
            Events.emit("build.after");
        },
        /**
     * Adds `type` class to the glide element.
     *
     * @return {Void}
     */ typeClass: function typeClass() {
            Components.Html.root.classList.add(Glide.settings.classes.type[Glide.settings.type]);
        },
        /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */ activeClass: function activeClass() {
            var classes = Glide.settings.classes;
            var slide = Components.Html.slides[Glide.index];
            if (slide) {
                slide.classList.add(classes.slide.active);
                $e4cadc049684851d$var$siblings(slide).forEach(function(sibling) {
                    sibling.classList.remove(classes.slide.active);
                });
            }
        },
        /**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */ removeClasses: function removeClasses() {
            var _Glide$settings$class = Glide.settings.classes, type = _Glide$settings$class.type, slide = _Glide$settings$class.slide;
            Components.Html.root.classList.remove(type[Glide.settings.type]);
            Components.Html.slides.forEach(function(sibling) {
                sibling.classList.remove(slide.active);
            });
        }
    };
    /**
   * Clear building classes:
   * - on destroying to bring HTML to its initial state
   * - on updating to remove classes before remounting component
   */ Events.on([
        "destroy",
        "update"
    ], function() {
        Build.removeClasses();
    });
    /**
   * Remount component:
   * - on resizing of the window to calculate new dimensions
   * - on updating settings via API
   */ Events.on([
        "resize",
        "update"
    ], function() {
        Build.mount();
    });
    /**
   * Swap active class of current slide:
   * - after each move to the new index
   */ Events.on("move.after", function() {
        Build.activeClass();
    });
    return Build;
}
function $e4cadc049684851d$var$Clones(Glide, Components, Events) {
    var Clones = {
        /**
     * Create pattern map and collect slides to be cloned.
     */ mount: function mount() {
            this.items = [];
            if (Glide.isType("carousel")) this.items = this.collect();
        },
        /**
     * Collect clones with pattern.
     *
     * @return {[]}
     */ collect: function collect() {
            var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var slides = Components.Html.slides;
            var _Glide$settings = Glide.settings, perView = _Glide$settings.perView, classes = _Glide$settings.classes, cloningRatio = _Glide$settings.cloningRatio;
            if (slides.length > 0) {
                var peekIncrementer = +!!Glide.settings.peek;
                var cloneCount = perView + peekIncrementer + Math.round(perView / 2);
                var append = slides.slice(0, cloneCount).reverse();
                var prepend = slides.slice(cloneCount * -1);
                for(var r = 0; r < Math.max(cloningRatio, Math.floor(perView / slides.length)); r++){
                    for(var i = 0; i < append.length; i++){
                        var clone = append[i].cloneNode(true);
                        clone.classList.add(classes.slide.clone);
                        items.push(clone);
                    }
                    for(var _i = 0; _i < prepend.length; _i++){
                        var _clone = prepend[_i].cloneNode(true);
                        _clone.classList.add(classes.slide.clone);
                        items.unshift(_clone);
                    }
                }
            }
            return items;
        },
        /**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */ append: function append() {
            var items = this.items;
            var _Components$Html = Components.Html, wrapper = _Components$Html.wrapper, slides = _Components$Html.slides;
            var half = Math.floor(items.length / 2);
            var prepend = items.slice(0, half).reverse();
            var append = items.slice(half * -1).reverse();
            var width = "".concat(Components.Sizes.slideWidth, "px");
            for(var i = 0; i < append.length; i++)wrapper.appendChild(append[i]);
            for(var _i2 = 0; _i2 < prepend.length; _i2++)wrapper.insertBefore(prepend[_i2], slides[0]);
            for(var _i3 = 0; _i3 < items.length; _i3++)items[_i3].style.width = width;
        },
        /**
     * Remove all cloned slides.
     *
     * @return {Void}
     */ remove: function remove() {
            var items = this.items;
            for(var i = 0; i < items.length; i++)Components.Html.wrapper.removeChild(items[i]);
        }
    };
    $e4cadc049684851d$var$define(Clones, "grow", {
        /**
     * Gets additional dimensions value caused by clones.
     *
     * @return {Number}
     */ get: function get() {
            return (Components.Sizes.slideWidth + Components.Gaps.value) * Clones.items.length;
        }
    });
    /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */ Events.on("update", function() {
        Clones.remove();
        Clones.mount();
        Clones.append();
    });
    /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */ Events.on("build.before", function() {
        if (Glide.isType("carousel")) Clones.append();
    });
    /**
   * Remove clones HTMLElements:
   * - on destroying, to bring HTML to its initial state
   */ Events.on("destroy", function() {
        Clones.remove();
    });
    return Clones;
}
var $e4cadc049684851d$var$EventsBinder = /*#__PURE__*/ function() {
    /**
   * Construct a EventsBinder instance.
   */ function EventsBinder() {
        var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $e4cadc049684851d$var$_classCallCheck(this, EventsBinder);
        this.listeners = listeners;
    }
    /**
   * Adds events listeners to arrows HTML elements.
   *
   * @param  {String|Array} events
   * @param  {Element|Window|Document} el
   * @param  {Function} closure
   * @param  {Boolean|Object} capture
   * @return {Void}
   */ $e4cadc049684851d$var$_createClass(EventsBinder, [
        {
            key: "on",
            value: function on(events, el, closure) {
                var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                if ($e4cadc049684851d$var$isString(events)) events = [
                    events
                ];
                for(var i = 0; i < events.length; i++){
                    this.listeners[events[i]] = closure;
                    el.addEventListener(events[i], this.listeners[events[i]], capture);
                }
            }
        },
        {
            key: "off",
            value: function off(events, el) {
                var capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                if ($e4cadc049684851d$var$isString(events)) events = [
                    events
                ];
                for(var i = 0; i < events.length; i++)el.removeEventListener(events[i], this.listeners[events[i]], capture);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                delete this.listeners;
            }
        }
    ]);
    return EventsBinder;
}();
function $e4cadc049684851d$var$Resize(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $e4cadc049684851d$var$EventsBinder();
    var Resize = {
        /**
     * Initializes window bindings.
     */ mount: function mount() {
            this.bind();
        },
        /**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on("resize", window, $e4cadc049684851d$var$throttle(function() {
                Events.emit("resize");
            }, Glide.settings.throttle));
        },
        /**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off("resize", window);
        }
    };
    /**
   * Remove bindings from window:
   * - on destroying, to remove added EventListener
   */ Events.on("destroy", function() {
        Resize.unbind();
        Binder.destroy();
    });
    return Resize;
}
var $e4cadc049684851d$var$VALID_DIRECTIONS = [
    "ltr",
    "rtl"
];
var $e4cadc049684851d$var$FLIPED_MOVEMENTS = {
    ">": "<",
    "<": ">",
    "=": "="
};
function $e4cadc049684851d$var$Direction(Glide, Components, Events) {
    var Direction = {
        /**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */ mount: function mount() {
            this.value = Glide.settings.direction;
        },
        /**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */ resolve: function resolve(pattern) {
            var token = pattern.slice(0, 1);
            if (this.is("rtl")) return pattern.split(token).join($e4cadc049684851d$var$FLIPED_MOVEMENTS[token]);
            return pattern;
        },
        /**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */ is: function is(direction) {
            return this.value === direction;
        },
        /**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */ addClass: function addClass() {
            Components.Html.root.classList.add(Glide.settings.classes.direction[this.value]);
        },
        /**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */ removeClass: function removeClass() {
            Components.Html.root.classList.remove(Glide.settings.classes.direction[this.value]);
        }
    };
    $e4cadc049684851d$var$define(Direction, "value", {
        /**
     * Gets value of the direction.
     *
     * @returns {Number}
     */ get: function get() {
            return Direction._v;
        },
        /**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */ set: function set(value) {
            if ($e4cadc049684851d$var$VALID_DIRECTIONS.indexOf(value) > -1) Direction._v = value;
            else $e4cadc049684851d$var$warn("Direction value must be `ltr` or `rtl`");
        }
    });
    /**
   * Clear direction class:
   * - on destroy to bring HTML to its initial state
   * - on update to remove class before reappling bellow
   */ Events.on([
        "destroy",
        "update"
    ], function() {
        Direction.removeClass();
    });
    /**
   * Remount component:
   * - on update to reflect changes in direction value
   */ Events.on("update", function() {
        Direction.mount();
    });
    /**
   * Apply direction class:
   * - before building to apply class for the first time
   * - on updating to reapply direction class that may changed
   */ Events.on([
        "build.before",
        "update"
    ], function() {
        Direction.addClass();
    });
    return Direction;
}
/**
 * Reflects value of glide movement.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $e4cadc049684851d$var$Rtl(Glide, Components) {
    return {
        /**
     * Negates the passed translate if glide is in RTL option.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            if (Components.Direction.is("rtl")) return -translate;
            return translate;
        }
    };
}
/**
 * Updates glide movement with a `gap` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $e4cadc049684851d$var$Gap(Glide, Components) {
    return {
        /**
     * Modifies passed translate value with number in the `gap` settings.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            var multiplier = Math.floor(translate / Components.Sizes.slideWidth);
            return translate + Components.Gaps.value * multiplier;
        }
    };
}
/**
 * Updates glide movement with width of additional clones width.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $e4cadc049684851d$var$Grow(Glide, Components) {
    return {
        /**
     * Adds to the passed translate width of the half of clones.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            return translate + Components.Clones.grow / 2;
        }
    };
}
/**
 * Updates glide movement with a `peek` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $e4cadc049684851d$var$Peeking(Glide, Components) {
    return {
        /**
     * Modifies passed translate value with a `peek` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            if (Glide.settings.focusAt >= 0) {
                var peek = Components.Peek.value;
                if ($e4cadc049684851d$var$isObject(peek)) return translate - peek.before;
                return translate - peek;
            }
            return translate;
        }
    };
}
/**
 * Updates glide movement with a `focusAt` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $e4cadc049684851d$var$Focusing(Glide, Components) {
    return {
        /**
     * Modifies passed translate value with index in the `focusAt` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            var gap = Components.Gaps.value;
            var width = Components.Sizes.width;
            var focusAt = Glide.settings.focusAt;
            var slideWidth = Components.Sizes.slideWidth;
            if (focusAt === "center") return translate - (width / 2 - slideWidth / 2);
            return translate - slideWidth * focusAt - gap * focusAt;
        }
    };
}
/**
 * Applies diffrent transformers on translate value.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $e4cadc049684851d$var$mutator(Glide, Components, Events) {
    /**
   * Merge instance transformers with collection of default transformers.
   * It's important that the Rtl component be last on the list,
   * so it reflects all previous transformations.
   *
   * @type {Array}
   */ var TRANSFORMERS = [
        $e4cadc049684851d$var$Gap,
        $e4cadc049684851d$var$Grow,
        $e4cadc049684851d$var$Peeking,
        $e4cadc049684851d$var$Focusing
    ].concat(Glide._t, [
        $e4cadc049684851d$var$Rtl
    ]);
    return {
        /**
     * Piplines translate value with registered transformers.
     *
     * @param  {Number} translate
     * @return {Number}
     */ mutate: function mutate(translate) {
            for(var i = 0; i < TRANSFORMERS.length; i++){
                var transformer = TRANSFORMERS[i];
                if ($e4cadc049684851d$var$isFunction(transformer) && $e4cadc049684851d$var$isFunction(transformer().modify)) translate = transformer(Glide, Components, Events).modify(translate);
                else $e4cadc049684851d$var$warn("Transformer should be a function that returns an object with `modify()` method");
            }
            return translate;
        }
    };
}
function $e4cadc049684851d$var$Translate(Glide, Components, Events) {
    var Translate = {
        /**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */ set: function set(value) {
            var transform = $e4cadc049684851d$var$mutator(Glide, Components).mutate(value);
            var translate3d = "translate3d(".concat(-1 * transform, "px, 0px, 0px)");
            Components.Html.wrapper.style.mozTransform = translate3d; // needed for supported Firefox 10-15
            Components.Html.wrapper.style.webkitTransform = translate3d; // needed for supported Chrome 10-35, Safari 5.1-8, and Opera 15-22
            Components.Html.wrapper.style.transform = translate3d;
        },
        /**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */ remove: function remove() {
            Components.Html.wrapper.style.transform = "";
        },
        /**
     * @return {number}
     */ getStartIndex: function getStartIndex() {
            var length = Components.Sizes.length;
            var index = Glide.index;
            var perView = Glide.settings.perView;
            if (Components.Run.isOffset(">") || Components.Run.isOffset("|>")) return length + (index - perView);
             // "modulo length" converts an index that equals length to zero
            return (index + perView) % length;
        },
        /**
     * @return {number}
     */ getTravelDistance: function getTravelDistance() {
            var travelDistance = Components.Sizes.slideWidth * Glide.settings.perView;
            if (Components.Run.isOffset(">") || Components.Run.isOffset("|>")) // reverse travel distance so that we don't have to change subtract operations
            return travelDistance * -1;
            return travelDistance;
        }
    };
    /**
   * Set new translate value:
   * - on move to reflect index change
   * - on updating via API to reflect possible changes in options
   */ Events.on("move", function(context) {
        if (!Glide.isType("carousel") || !Components.Run.isOffset()) return Translate.set(context.movement);
        Components.Transition.after(function() {
            Events.emit("translate.jump");
            Translate.set(Components.Sizes.slideWidth * Glide.index);
        });
        var startWidth = Components.Sizes.slideWidth * Components.Translate.getStartIndex();
        return Translate.set(startWidth - Components.Translate.getTravelDistance());
    });
    /**
   * Remove translate:
   * - on destroying to bring markup to its inital state
   */ Events.on("destroy", function() {
        Translate.remove();
    });
    return Translate;
}
function $e4cadc049684851d$var$Transition(Glide, Components, Events) {
    /**
   * Holds inactivity status of transition.
   * When true transition is not applied.
   *
   * @type {Boolean}
   */ var disabled = false;
    var Transition = {
        /**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */ compose: function compose(property) {
            var settings = Glide.settings;
            if (disabled) return "".concat(property, " 0ms ").concat(settings.animationTimingFunc);
            return "".concat(property, " ").concat(this.duration, "ms ").concat(settings.animationTimingFunc);
        },
        /**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */ set: function set() {
            var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "transform";
            Components.Html.wrapper.style.transition = this.compose(property);
        },
        /**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */ remove: function remove() {
            Components.Html.wrapper.style.transition = "";
        },
        /**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */ after: function after(callback) {
            setTimeout(function() {
                callback();
            }, this.duration);
        },
        /**
     * Enable transition.
     *
     * @return {Void}
     */ enable: function enable() {
            disabled = false;
            this.set();
        },
        /**
     * Disable transition.
     *
     * @return {Void}
     */ disable: function disable() {
            disabled = true;
            this.set();
        }
    };
    $e4cadc049684851d$var$define(Transition, "duration", {
        /**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */ get: function get() {
            var settings = Glide.settings;
            if (Glide.isType("slider") && Components.Run.offset) return settings.rewindDuration;
            return settings.animationDuration;
        }
    });
    /**
   * Set transition `style` value:
   * - on each moving, because it may be cleared by offset move
   */ Events.on("move", function() {
        Transition.set();
    });
    /**
   * Disable transition:
   * - before initial build to avoid transitioning from `0` to `startAt` index
   * - while resizing window and recalculating dimensions
   * - on jumping from offset transition at start and end edges in `carousel` type
   */ Events.on([
        "build.before",
        "resize",
        "translate.jump"
    ], function() {
        Transition.disable();
    });
    /**
   * Enable transition:
   * - on each running, because it may be disabled by offset move
   */ Events.on("run", function() {
        Transition.enable();
    });
    /**
   * Remove transition:
   * - on destroying to bring markup to its inital state
   */ Events.on("destroy", function() {
        Transition.remove();
    });
    return Transition;
}
/**
 * Test via a getter in the options object to see
 * if the passive property is accessed.
 *
 * @see https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
 */ var $e4cadc049684851d$var$supportsPassive = false;
try {
    var $e4cadc049684851d$var$opts = Object.defineProperty({}, "passive", {
        get: function get() {
            $e4cadc049684851d$var$supportsPassive = true;
        }
    });
    window.addEventListener("testPassive", null, $e4cadc049684851d$var$opts);
    window.removeEventListener("testPassive", null, $e4cadc049684851d$var$opts);
} catch (e) {}
var $e4cadc049684851d$var$supportsPassive$1 = $e4cadc049684851d$var$supportsPassive;
var $e4cadc049684851d$var$START_EVENTS = [
    "touchstart",
    "mousedown"
];
var $e4cadc049684851d$var$MOVE_EVENTS = [
    "touchmove",
    "mousemove"
];
var $e4cadc049684851d$var$END_EVENTS = [
    "touchend",
    "touchcancel",
    "mouseup",
    "mouseleave"
];
var $e4cadc049684851d$var$MOUSE_EVENTS = [
    "mousedown",
    "mousemove",
    "mouseup",
    "mouseleave"
];
function $e4cadc049684851d$var$Swipe(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $e4cadc049684851d$var$EventsBinder();
    var swipeSin = 0;
    var swipeStartX = 0;
    var swipeStartY = 0;
    var disabled = false;
    var capture = $e4cadc049684851d$var$supportsPassive$1 ? {
        passive: true
    } : false;
    var Swipe = {
        /**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */ mount: function mount() {
            this.bindSwipeStart();
        },
        /**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */ start: function start(event) {
            if (!disabled && !Glide.disabled) {
                this.disable();
                var swipe = this.touches(event);
                swipeSin = null;
                swipeStartX = $e4cadc049684851d$var$toInt(swipe.pageX);
                swipeStartY = $e4cadc049684851d$var$toInt(swipe.pageY);
                this.bindSwipeMove();
                this.bindSwipeEnd();
                Events.emit("swipe.start");
            }
        },
        /**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */ move: function move(event) {
            if (!Glide.disabled) {
                var _Glide$settings = Glide.settings, touchAngle = _Glide$settings.touchAngle, touchRatio = _Glide$settings.touchRatio, classes = _Glide$settings.classes;
                var swipe = this.touches(event);
                var subExSx = $e4cadc049684851d$var$toInt(swipe.pageX) - swipeStartX;
                var subEySy = $e4cadc049684851d$var$toInt(swipe.pageY) - swipeStartY;
                var powEX = Math.abs(subExSx << 2);
                var powEY = Math.abs(subEySy << 2);
                var swipeHypotenuse = Math.sqrt(powEX + powEY);
                var swipeCathetus = Math.sqrt(powEY);
                swipeSin = Math.asin(swipeCathetus / swipeHypotenuse);
                if (swipeSin * 180 / Math.PI < touchAngle) {
                    event.stopPropagation();
                    Components.Move.make(subExSx * $e4cadc049684851d$var$toFloat(touchRatio));
                    Components.Html.root.classList.add(classes.dragging);
                    Events.emit("swipe.move");
                } else return false;
            }
        },
        /**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */ end: function end(event) {
            if (!Glide.disabled) {
                var _Glide$settings2 = Glide.settings, perSwipe = _Glide$settings2.perSwipe, touchAngle = _Glide$settings2.touchAngle, classes = _Glide$settings2.classes;
                var swipe = this.touches(event);
                var threshold = this.threshold(event);
                var swipeDistance = swipe.pageX - swipeStartX;
                var swipeDeg = swipeSin * 180 / Math.PI;
                this.enable();
                if (swipeDistance > threshold && swipeDeg < touchAngle) Components.Run.make(Components.Direction.resolve("".concat(perSwipe, "<")));
                else if (swipeDistance < -threshold && swipeDeg < touchAngle) Components.Run.make(Components.Direction.resolve("".concat(perSwipe, ">")));
                else // While swipe don't reach distance apply previous transform.
                Components.Move.make();
                Components.Html.root.classList.remove(classes.dragging);
                this.unbindSwipeMove();
                this.unbindSwipeEnd();
                Events.emit("swipe.end");
            }
        },
        /**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */ bindSwipeStart: function bindSwipeStart() {
            var _this = this;
            var _Glide$settings3 = Glide.settings, swipeThreshold = _Glide$settings3.swipeThreshold, dragThreshold = _Glide$settings3.dragThreshold;
            if (swipeThreshold) Binder.on($e4cadc049684851d$var$START_EVENTS[0], Components.Html.wrapper, function(event) {
                _this.start(event);
            }, capture);
            if (dragThreshold) Binder.on($e4cadc049684851d$var$START_EVENTS[1], Components.Html.wrapper, function(event) {
                _this.start(event);
            }, capture);
        },
        /**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */ unbindSwipeStart: function unbindSwipeStart() {
            Binder.off($e4cadc049684851d$var$START_EVENTS[0], Components.Html.wrapper, capture);
            Binder.off($e4cadc049684851d$var$START_EVENTS[1], Components.Html.wrapper, capture);
        },
        /**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */ bindSwipeMove: function bindSwipeMove() {
            var _this2 = this;
            Binder.on($e4cadc049684851d$var$MOVE_EVENTS, Components.Html.wrapper, $e4cadc049684851d$var$throttle(function(event) {
                _this2.move(event);
            }, Glide.settings.throttle), capture);
        },
        /**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */ unbindSwipeMove: function unbindSwipeMove() {
            Binder.off($e4cadc049684851d$var$MOVE_EVENTS, Components.Html.wrapper, capture);
        },
        /**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */ bindSwipeEnd: function bindSwipeEnd() {
            var _this3 = this;
            Binder.on($e4cadc049684851d$var$END_EVENTS, Components.Html.wrapper, function(event) {
                _this3.end(event);
            });
        },
        /**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */ unbindSwipeEnd: function unbindSwipeEnd() {
            Binder.off($e4cadc049684851d$var$END_EVENTS, Components.Html.wrapper);
        },
        /**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */ touches: function touches(event) {
            if ($e4cadc049684851d$var$MOUSE_EVENTS.indexOf(event.type) > -1) return event;
            return event.touches[0] || event.changedTouches[0];
        },
        /**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */ threshold: function threshold(event) {
            var settings = Glide.settings;
            if ($e4cadc049684851d$var$MOUSE_EVENTS.indexOf(event.type) > -1) return settings.dragThreshold;
            return settings.swipeThreshold;
        },
        /**
     * Enables swipe event.
     *
     * @return {self}
     */ enable: function enable() {
            disabled = false;
            Components.Transition.enable();
            return this;
        },
        /**
     * Disables swipe event.
     *
     * @return {self}
     */ disable: function disable() {
            disabled = true;
            Components.Transition.disable();
            return this;
        }
    };
    /**
   * Add component class:
   * - after initial building
   */ Events.on("build.after", function() {
        Components.Html.root.classList.add(Glide.settings.classes.swipeable);
    });
    /**
   * Remove swiping bindings:
   * - on destroying, to remove added EventListeners
   */ Events.on("destroy", function() {
        Swipe.unbindSwipeStart();
        Swipe.unbindSwipeMove();
        Swipe.unbindSwipeEnd();
        Binder.destroy();
    });
    return Swipe;
}
function $e4cadc049684851d$var$Images(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $e4cadc049684851d$var$EventsBinder();
    var Images = {
        /**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */ mount: function mount() {
            this.bind();
        },
        /**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on("dragstart", Components.Html.wrapper, this.dragstart);
        },
        /**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off("dragstart", Components.Html.wrapper);
        },
        /**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */ dragstart: function dragstart(event) {
            event.preventDefault();
        }
    };
    /**
   * Remove bindings from images:
   * - on destroying, to remove added EventListeners
   */ Events.on("destroy", function() {
        Images.unbind();
        Binder.destroy();
    });
    return Images;
}
function $e4cadc049684851d$var$Anchors(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $e4cadc049684851d$var$EventsBinder();
    /**
   * Holds detaching status of anchors.
   * Prevents detaching of already detached anchors.
   *
   * @private
   * @type {Boolean}
   */ var detached = false;
    /**
   * Holds preventing status of anchors.
   * If `true` redirection after click will be disabled.
   *
   * @private
   * @type {Boolean}
   */ var prevented = false;
    var Anchors = {
        /**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */ mount: function mount() {
            /**
       * Holds collection of anchors elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._a = Components.Html.wrapper.querySelectorAll("a");
            this.bind();
        },
        /**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on("click", Components.Html.wrapper, this.click);
        },
        /**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off("click", Components.Html.wrapper);
        },
        /**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */ click: function click(event) {
            if (prevented) {
                event.stopPropagation();
                event.preventDefault();
            }
        },
        /**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */ detach: function detach() {
            prevented = true;
            if (!detached) {
                for(var i = 0; i < this.items.length; i++)this.items[i].draggable = false;
                detached = true;
            }
            return this;
        },
        /**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */ attach: function attach() {
            prevented = false;
            if (detached) {
                for(var i = 0; i < this.items.length; i++)this.items[i].draggable = true;
                detached = false;
            }
            return this;
        }
    };
    $e4cadc049684851d$var$define(Anchors, "items", {
        /**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */ get: function get() {
            return Anchors._a;
        }
    });
    /**
   * Detach anchors inside slides:
   * - on swiping, so they won't redirect to its `href` attributes
   */ Events.on("swipe.move", function() {
        Anchors.detach();
    });
    /**
   * Attach anchors inside slides:
   * - after swiping and transitions ends, so they can redirect after click again
   */ Events.on("swipe.end", function() {
        Components.Transition.after(function() {
            Anchors.attach();
        });
    });
    /**
   * Unbind anchors inside slides:
   * - on destroying, to bring anchors to its initial state
   */ Events.on("destroy", function() {
        Anchors.attach();
        Anchors.unbind();
        Binder.destroy();
    });
    return Anchors;
}
var $e4cadc049684851d$var$NAV_SELECTOR = '[data-glide-el="controls[nav]"]';
var $e4cadc049684851d$var$CONTROLS_SELECTOR = '[data-glide-el^="controls"]';
var $e4cadc049684851d$var$PREVIOUS_CONTROLS_SELECTOR = "".concat($e4cadc049684851d$var$CONTROLS_SELECTOR, ' [data-glide-dir*="<"]');
var $e4cadc049684851d$var$NEXT_CONTROLS_SELECTOR = "".concat($e4cadc049684851d$var$CONTROLS_SELECTOR, ' [data-glide-dir*=">"]');
function $e4cadc049684851d$var$Controls(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $e4cadc049684851d$var$EventsBinder();
    var capture = $e4cadc049684851d$var$supportsPassive$1 ? {
        passive: true
    } : false;
    var Controls = {
        /**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */ mount: function mount() {
            /**
       * Collection of navigation HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._n = Components.Html.root.querySelectorAll($e4cadc049684851d$var$NAV_SELECTOR);
            /**
       * Collection of controls HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._c = Components.Html.root.querySelectorAll($e4cadc049684851d$var$CONTROLS_SELECTOR);
            /**
       * Collection of arrow control HTML elements.
       *
       * @private
       * @type {Object}
       */ this._arrowControls = {
                previous: Components.Html.root.querySelectorAll($e4cadc049684851d$var$PREVIOUS_CONTROLS_SELECTOR),
                next: Components.Html.root.querySelectorAll($e4cadc049684851d$var$NEXT_CONTROLS_SELECTOR)
            };
            this.addBindings();
        },
        /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */ setActive: function setActive() {
            for(var i = 0; i < this._n.length; i++)this.addClass(this._n[i].children);
        },
        /**
     * Removes active class to current slide.
     *
     * @return {Void}
     */ removeActive: function removeActive() {
            for(var i = 0; i < this._n.length; i++)this.removeClass(this._n[i].children);
        },
        /**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */ addClass: function addClass(controls) {
            var settings = Glide.settings;
            var item = controls[Glide.index];
            if (!item) return;
            item.classList.add(settings.classes.nav.active);
            $e4cadc049684851d$var$siblings(item).forEach(function(sibling) {
                sibling.classList.remove(settings.classes.nav.active);
            });
        },
        /**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */ removeClass: function removeClass(controls) {
            var item = controls[Glide.index];
            item === null || item === void 0 || item.classList.remove(Glide.settings.classes.nav.active);
        },
        /**
     * Calculates, removes or adds `Glide.settings.classes.disabledArrow` class on the control arrows
     */ setArrowState: function setArrowState() {
            if (Glide.settings.rewind) return;
            var next = Controls._arrowControls.next;
            var previous = Controls._arrowControls.previous;
            this.resetArrowState(next, previous);
            if (Glide.index === 0) this.disableArrow(previous);
            if (Glide.index === Components.Run.length) this.disableArrow(next);
        },
        /**
     * Removes `Glide.settings.classes.disabledArrow` from given NodeList elements
     *
     * @param {NodeList[]} lists
     */ resetArrowState: function resetArrowState() {
            var settings = Glide.settings;
            for(var _len = arguments.length, lists = new Array(_len), _key = 0; _key < _len; _key++)lists[_key] = arguments[_key];
            lists.forEach(function(list) {
                $e4cadc049684851d$var$toArray(list).forEach(function(element) {
                    element.classList.remove(settings.classes.arrow.disabled);
                });
            });
        },
        /**
     * Adds `Glide.settings.classes.disabledArrow` to given NodeList elements
     *
     * @param {NodeList[]} lists
     */ disableArrow: function disableArrow() {
            var settings = Glide.settings;
            for(var _len2 = arguments.length, lists = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)lists[_key2] = arguments[_key2];
            lists.forEach(function(list) {
                $e4cadc049684851d$var$toArray(list).forEach(function(element) {
                    element.classList.add(settings.classes.arrow.disabled);
                });
            });
        },
        /**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */ addBindings: function addBindings() {
            for(var i = 0; i < this._c.length; i++)this.bind(this._c[i].children);
        },
        /**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */ removeBindings: function removeBindings() {
            for(var i = 0; i < this._c.length; i++)this.unbind(this._c[i].children);
        },
        /**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */ bind: function bind(elements) {
            for(var i = 0; i < elements.length; i++){
                Binder.on("click", elements[i], this.click);
                Binder.on("touchstart", elements[i], this.click, capture);
            }
        },
        /**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */ unbind: function unbind(elements) {
            for(var i = 0; i < elements.length; i++)Binder.off([
                "click",
                "touchstart"
            ], elements[i]);
        },
        /**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in direction given via the
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {void}
     */ click: function click(event) {
            if (!$e4cadc049684851d$var$supportsPassive$1 && event.type === "touchstart") event.preventDefault();
            var direction = event.currentTarget.getAttribute("data-glide-dir");
            Components.Run.make(Components.Direction.resolve(direction));
        }
    };
    $e4cadc049684851d$var$define(Controls, "items", {
        /**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */ get: function get() {
            return Controls._c;
        }
    });
    /**
   * Swap active class of current navigation item:
   * - after mounting to set it to initial index
   * - after each move to the new index
   */ Events.on([
        "mount.after",
        "move.after"
    ], function() {
        Controls.setActive();
    });
    /**
   * Add or remove disabled class of arrow elements
   */ Events.on([
        "mount.after",
        "run"
    ], function() {
        Controls.setArrowState();
    });
    /**
   * Remove bindings and HTML Classes:
   * - on destroying, to bring markup to its initial state
   */ Events.on("destroy", function() {
        Controls.removeBindings();
        Controls.removeActive();
        Binder.destroy();
    });
    return Controls;
}
function $e4cadc049684851d$var$Keyboard(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $e4cadc049684851d$var$EventsBinder();
    var Keyboard = {
        /**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */ mount: function mount() {
            if (Glide.settings.keyboard) this.bind();
        },
        /**
     * Adds keyboard press events.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on("keyup", document, this.press);
        },
        /**
     * Removes keyboard press events.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off("keyup", document);
        },
        /**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */ press: function press(event) {
            var perSwipe = Glide.settings.perSwipe;
            var arrowSymbols = {
                ArrowRight: ">",
                ArrowLeft: "<"
            };
            if ([
                "ArrowRight",
                "ArrowLeft"
            ].includes(event.code)) Components.Run.make(Components.Direction.resolve("".concat(perSwipe).concat(arrowSymbols[event.code])));
        }
    };
    /**
   * Remove bindings from keyboard:
   * - on destroying to remove added events
   * - on updating to remove events before remounting
   */ Events.on([
        "destroy",
        "update"
    ], function() {
        Keyboard.unbind();
    });
    /**
   * Remount component
   * - on updating to reflect potential changes in settings
   */ Events.on("update", function() {
        Keyboard.mount();
    });
    /**
   * Destroy binder:
   * - on destroying to remove listeners
   */ Events.on("destroy", function() {
        Binder.destroy();
    });
    return Keyboard;
}
function $e4cadc049684851d$var$Autoplay(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $e4cadc049684851d$var$EventsBinder();
    var Autoplay = {
        /**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */ mount: function mount() {
            this.enable();
            this.start();
            if (Glide.settings.hoverpause) this.bind();
        },
        /**
     * Enables autoplaying
     *
     * @returns {Void}
     */ enable: function enable() {
            this._e = true;
        },
        /**
     * Disables autoplaying.
     *
     * @returns {Void}
     */ disable: function disable() {
            this._e = false;
        },
        /**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */ start: function start() {
            var _this = this;
            if (!this._e) return;
            this.enable();
            if (Glide.settings.autoplay) {
                if ($e4cadc049684851d$var$isUndefined(this._i)) this._i = setInterval(function() {
                    _this.stop();
                    Components.Run.make(">");
                    _this.start();
                    Events.emit("autoplay");
                }, this.time);
            }
        },
        /**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */ stop: function stop() {
            this._i = clearInterval(this._i);
        },
        /**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */ bind: function bind() {
            var _this2 = this;
            Binder.on("mouseover", Components.Html.root, function() {
                if (_this2._e) _this2.stop();
            });
            Binder.on("mouseout", Components.Html.root, function() {
                if (_this2._e) _this2.start();
            });
        },
        /**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */ unbind: function unbind() {
            Binder.off([
                "mouseover",
                "mouseout"
            ], Components.Html.root);
        }
    };
    $e4cadc049684851d$var$define(Autoplay, "time", {
        /**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */ get: function get() {
            var autoplay = Components.Html.slides[Glide.index].getAttribute("data-glide-autoplay");
            if (autoplay) return $e4cadc049684851d$var$toInt(autoplay);
            return $e4cadc049684851d$var$toInt(Glide.settings.autoplay);
        }
    });
    /**
   * Stop autoplaying and unbind events:
   * - on destroying, to clear defined interval
   * - on updating via API to reset interval that may changed
   */ Events.on([
        "destroy",
        "update"
    ], function() {
        Autoplay.unbind();
    });
    /**
   * Stop autoplaying:
   * - before each run, to restart autoplaying
   * - on pausing via API
   * - on destroying, to clear defined interval
   * - while starting a swipe
   * - on updating via API to reset interval that may changed
   */ Events.on([
        "run.before",
        "swipe.start",
        "update"
    ], function() {
        Autoplay.stop();
    });
    Events.on([
        "pause",
        "destroy"
    ], function() {
        Autoplay.disable();
        Autoplay.stop();
    });
    /**
   * Start autoplaying:
   * - after each run, to restart autoplaying
   * - on playing via API
   * - while ending a swipe
   */ Events.on([
        "run.after",
        "swipe.end"
    ], function() {
        Autoplay.start();
    });
    /**
   * Start autoplaying:
   * - after each run, to restart autoplaying
   * - on playing via API
   * - while ending a swipe
   */ Events.on([
        "play"
    ], function() {
        Autoplay.enable();
        Autoplay.start();
    });
    /**
   * Remount autoplaying:
   * - on updating via API to reset interval that may changed
   */ Events.on("update", function() {
        Autoplay.mount();
    });
    /**
   * Destroy a binder:
   * - on destroying glide instance to clearup listeners
   */ Events.on("destroy", function() {
        Binder.destroy();
    });
    return Autoplay;
}
/**
 * Sorts keys of breakpoint object so they will be ordered from lower to bigger.
 *
 * @param {Object} points
 * @returns {Object}
 */ function $e4cadc049684851d$var$sortBreakpoints(points) {
    if ($e4cadc049684851d$var$isObject(points)) return $e4cadc049684851d$var$sortKeys(points);
    else $e4cadc049684851d$var$warn("Breakpoints option must be an object");
    return {};
}
function $e4cadc049684851d$var$Breakpoints(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $e4cadc049684851d$var$EventsBinder();
    /**
   * Holds reference to settings.
   *
   * @type {Object}
   */ var settings = Glide.settings;
    /**
   * Holds reference to breakpoints object in settings. Sorts breakpoints
   * from smaller to larger. It is required in order to proper
   * matching currently active breakpoint settings.
   *
   * @type {Object}
   */ var points = $e4cadc049684851d$var$sortBreakpoints(settings.breakpoints);
    /**
   * Cache initial settings before overwritting.
   *
   * @type {Object}
   */ var defaults = Object.assign({}, settings);
    var Breakpoints = {
        /**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */ match: function match(points) {
            if (typeof window.matchMedia !== "undefined") {
                for(var point in points)if (points.hasOwnProperty(point)) {
                    if (window.matchMedia("(max-width: ".concat(point, "px)")).matches) return points[point];
                }
            }
            return defaults;
        }
    };
    /**
   * Overwrite instance settings with currently matching breakpoint settings.
   * This happens right after component initialization.
   */ Object.assign(settings, Breakpoints.match(points));
    /**
   * Update glide with settings of matched brekpoint:
   * - window resize to update slider
   */ Binder.on("resize", window, $e4cadc049684851d$var$throttle(function() {
        Glide.settings = $e4cadc049684851d$var$mergeOptions(settings, Breakpoints.match(points));
    }, Glide.settings.throttle));
    /**
   * Resort and update default settings:
   * - on reinit via API, so breakpoint matching will be performed with options
   */ Events.on("update", function() {
        points = $e4cadc049684851d$var$sortBreakpoints(points);
        defaults = Object.assign({}, settings);
    });
    /**
   * Unbind resize listener:
   * - on destroying, to bring markup to its initial state
   */ Events.on("destroy", function() {
        Binder.off("resize", window);
    });
    return Breakpoints;
}
var $e4cadc049684851d$var$COMPONENTS = {
    // Required
    Html: $e4cadc049684851d$var$Html,
    Translate: $e4cadc049684851d$var$Translate,
    Transition: $e4cadc049684851d$var$Transition,
    Direction: $e4cadc049684851d$var$Direction,
    Peek: $e4cadc049684851d$var$Peek,
    Sizes: $e4cadc049684851d$var$Sizes,
    Gaps: $e4cadc049684851d$var$Gaps,
    Move: $e4cadc049684851d$var$Move,
    Clones: $e4cadc049684851d$var$Clones,
    Resize: $e4cadc049684851d$var$Resize,
    Build: $e4cadc049684851d$var$Build,
    Run: $e4cadc049684851d$var$Run,
    // Optional
    Swipe: $e4cadc049684851d$var$Swipe,
    Images: $e4cadc049684851d$var$Images,
    Anchors: $e4cadc049684851d$var$Anchors,
    Controls: $e4cadc049684851d$var$Controls,
    Keyboard: $e4cadc049684851d$var$Keyboard,
    Autoplay: $e4cadc049684851d$var$Autoplay,
    Breakpoints: $e4cadc049684851d$var$Breakpoints
};
var $e4cadc049684851d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Core) {
    $e4cadc049684851d$var$_inherits(Glide, _Core);
    var _super = $e4cadc049684851d$var$_createSuper(Glide);
    function Glide() {
        $e4cadc049684851d$var$_classCallCheck(this, Glide);
        return _super.apply(this, arguments);
    }
    $e4cadc049684851d$var$_createClass(Glide, [
        {
            key: "mount",
            value: function mount() {
                var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return $e4cadc049684851d$var$_get($e4cadc049684851d$var$_getPrototypeOf(Glide.prototype), "mount", this).call(this, Object.assign({}, $e4cadc049684851d$var$COMPONENTS, extensions));
            }
        }
    ]);
    return Glide;
}($e4cadc049684851d$var$Glide$1);


class $a51c7973921171ed$var$LandingPage {
    constructor(globalStore, container){
        this.globalStore = globalStore || {};
        this.container = container || document.querySelector(".project-main");
        this._init();
    }
    _init = async ()=>{
        this.ui = await this.makelandingUi();
        this.addEvents(this.ui);
    };
    makelandingUi = async ()=>{
        this.container.innerHTML = `
    <div class="landing-page-main-container">
    <div class="landing-page-navbar">
        <a href="/"><img src="${0, (/*@__PURE__*/$parcel$interopDefault($5PfYl))}"></a>
        <img src="${0, (/*@__PURE__*/$parcel$interopDefault($cuiEO))}" width="48" height="48" class="hamburger-icon">
        <div class="navbar-link-header">
            <a class="navbar-link navbar-active-link" id="home-nav">Home</a>
            <a class="navbar-link contact-us-menu-button" id="contact-nav">Contact Us</a>
            <a class="navbar-link" href="${(0, $DkdI3.default).production}/client" id="client-nav">Client</a>
            <a class="navbar-link" href="${(0, $DkdI3.default).production}/vendors" id="vendor-nav">Vendor</a>
            <a class="navbar-link" href="${(0, $DkdI3.default).production}/operator" id="operator-nav">Operator</a>
        </div>
    </div>

    <hr class="navbar-border">

    <div class="home-page-container" >

        <div class="landing-page-top-container">
            <p class="landing-top-top-text">Employee Transportation Meets <span>Automation Excellence</span></p>
            <p class="landing-top-middle-text">Unveil the Future of Employee Mobility</p>
            <p class="landing-top-bottom-text">At VM Routes, we navigate the future of corporate transportation through cutting-edge automation solutions. Elevate your workforce's journey with our innovative services that re-imagine employee transportation.</p>
    
        </div>

        <div class="landing-features-bg-container">
            <img src="${0, (/*@__PURE__*/$parcel$interopDefault($059849b7da6603c6$exports))}" class="feature-bg-image">
            <div class="landing-features-container">
                <div class="features-tab">
                    <img src="${0, (/*@__PURE__*/$parcel$interopDefault($f92ef9f37cf923cb$exports))}" class="features-icon">
                    <p class="features-title">Efficiency Unleashed</p>
                    <p class="features-body">Imagine a transportation system that optimizes routes, adjusts dynamically to changes, and ensures maximum efficiency in every ride. Our automation tools do just that, saving time and resources while keeping your workforce on the move.</p>
                </div>

                <div class="features-tab">
                    <img src="${0, (/*@__PURE__*/$parcel$interopDefault($2dfb4ebf6b2351a3$exports))}" class="features-icon">
                    <p class="features-title">Safety in Automation</p>
                    <p class="features-body">Safety is our priority. With automated tracking, real-time monitoring, and smart navigation, we guarantee a secure commuting experience, ensuring your employees' peace of mind on the road.</p>
                </div>

                <div class="features-tab">
                    <img src="${0, (/*@__PURE__*/$parcel$interopDefault($0ffaeadf21a031b7$exports))}" class="features-icon">
                    <p class="features-title">Precision in Planning</p>
                    <p class="features-body">Automation streamlines trip scheduling, ensuring precision and accuracy in pick-ups and drop-offs. Say goodbye to guesswork and hello to a well-organized transportation system.</p>
                </div>
            </div>
        </div>

        <div class="landing-genesis-container">

            <div class="landing-genesis-text-contaienr">
                <p class="genesis-text-header"><span>The</span> Genesis</p>
                <p class="genesis-text-body">Automation streamlines trip scheduling, ensuring precision and accuracy in pick-ups and drop-offs. Say goodbye to guesswork and hello to a well-organized transportation system.</p>
            </div>
            
            <div class="glide landing-genesis-parent">
                <div class="glide__track" data-glide-el="track">
                    <ul class="glide__slides">
                        <li class="glide__slide">
                            <div class="landing-genesis-card-container">
                                <img src="${0, (/*@__PURE__*/$parcel$interopDefault($c091c6a0b9d97cf3$exports))}" class="genesis-card-image">
                                <div class="genesis-card-text-container">
                                    <p class="genesis-card-title">Born in a Studio</p>
                                    <p class="genesis-card-title highlight-genesis">Not in an Office.!</p>
                                    <p class="genesis-card-body">VM Routes is one of our finest products born in our VirtualMaze studio not in our office. Designed by eminent team and developed by stalwarts of techies.</p>
                                </div>
                            </div>
                        </li>
                        <li class="glide__slide">
                            <div class="landing-genesis-card-container">
                                <img src="${0, (/*@__PURE__*/$parcel$interopDefault($2b47b7076fe7c659$exports))}" class="genesis-card-image">
                                <div class="genesis-card-text-container">
                                    <p class="genesis-card-title">Upgrade your Transport,
                                    <p class="genesis-card-title highlight-genesis">Upgrade your Future.!</p>
                                    <p class="genesis-card-body">VM Routes Employee Transportation Service by Virtualmaze Softsys revolutionizes employee transportation with tailored features, optimizing efficiency, safety, and cost-effectiveness for businesses.</p>
                                </div>
                            </div>
                        </li>
                        <li class="glide__slide">
                            <div class="landing-genesis-card-container">
                                <img src="${0, (/*@__PURE__*/$parcel$interopDefault($3f1e5e73bb1d8f35$exports))}" class="genesis-card-image">
                                <div class="genesis-card-text-container">
                                    <p class="genesis-card-title">The Impact of</p>
                                    <p class="genesis-card-title highlight-genesis">VM Routes</p>
                                    <p class="genesis-card-body">VM Routes Employee Transportation Service by Virtualmaze Softsys revolutionizes employee transportation with tailored features, optimizing efficiency, safety, and cost-effectiveness for businesses.</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="glide__bullets" data-glide-el="controls[nav]">
                    <button class="glide__bullet" data-glide-dir="=0"></button>
                    <button class="glide__bullet" data-glide-dir="=1"></button>
                    <button class="glide__bullet" data-glide-dir="=2"></button>
                </div>
            </div>
        </div>

        <div class="landing-transport-service-container">
            <div class="transport-left-container">
                <img src="${0, (/*@__PURE__*/$parcel$interopDefault($5PfYl))}" class="transport-vmroute-logo">
                <p class="employee-header-title"><span>Employee</span> Transport Service</p>
                <p class="employee-header-subtitle">Revolutionize Your Corporate Transport with VM Routes</p>
                <p class="employee-header-body">VM Routes is an intuitive software solution designed to streamline and simplify corporate transportation. From managing drivers and vehicles to optimizing routes and providing live tracking, it's your all-in-one platform for efficient and hassle-free employee travel."</p>
                <div class="transport-button-container">
                    <button class="request-demo-button">Request a Demo</button>
                    <button class="contact-us-button contact-us-menu-button">Contact Us</button>
                </div>

            </div>
            <img src="${0, (/*@__PURE__*/$parcel$interopDefault($8a088e5380f77345$exports))}" class="employee-side-image">
        </div>

        <div class="landing-why-vm-container">
            <p class="why-vm-title"><span>Why</span> VM Routes?</p>
            <div class="why-vm-card-parent-container">
                <div class="why-vm-card-container">
                    <img src="${0, (/*@__PURE__*/$parcel$interopDefault($4498c01e9bddc6d6$exports))}">
                    <p class="why-vm-card-title">Recognizing and Reducing Risks</p>
                    <p class="why-vm-card-body">Manual procedures provide only a limited opportunity for the team to guarantee their employees' safety.</p>
                </div>
                <div class="why-vm-card-container">
                    <img src="${0, (/*@__PURE__*/$parcel$interopDefault($67b87f2cbecfba18$exports))}">
                    <p class="why-vm-card-title">Enhancing Environmental, Social, and Governance (ESG) Adherence</p>
                    <p class="why-vm-card-body">Lower carbon emissions by opting for shared vehicle commuting and embracing electric vehicle (EV) adoption</p>
                </div>
                <div class="why-vm-card-container">
                    <img src="${0, (/*@__PURE__*/$parcel$interopDefault($3fad3f5914d0aa88$exports))}">
                    <p class="why-vm-card-title">Enhancing Employee Contentment</p>
                    <p class="why-vm-card-body">Guaranteeing employee satisfaction during their commute to work remains a universal challenge</p>
                </div>
            </div>
            
        </div>
        
        <div class="top-feature-container">
            <p class="top-features-title"><span>Top</span> Features</p>
            <div class="top-feature-card-container">
                <div class="top-feature-card">
                    <span class="top-feature-card-icon">
                        <img src="${0, (/*@__PURE__*/$parcel$interopDefault($4c2e637e645d74e9$exports))}">
                    </span>
                    <p class="top-feature-card-number">01</p>
                    <p class="top-feature-card-title">Scheduling</p>
                    <p class="top-feature-card-body">Rostering - Automatic/Manual Simplified Login</p>
                </div>

                <div class="top-feature-card">
                    <span class="top-feature-card-icon">
                        <img src="${0, (/*@__PURE__*/$parcel$interopDefault($bd9c3ac91e022899$exports))}">
                    </span>
                    <p class="top-feature-card-number">02</p>
                    <p class="top-feature-card-title">Routing</p>
                    <p class="top-feature-card-body">Geo Fencing Intelligent Routing Economize the Escorts</p>
                </div>

                <div class="top-feature-card">
                    <span class="top-feature-card-icon">
                        <img src="${0, (/*@__PURE__*/$parcel$interopDefault($1f48efcab23756ad$exports))}">
                    </span>
                    <p class="top-feature-card-number">03</p>
                    <p class="top-feature-card-title">Tracking</p>
                    <p class="top-feature-card-body">Live Tracking Vendor Tracking Portal Late Arrival Analysis</p>
                </div>

                <div class="top-feature-card">
                    <span class="top-feature-card-icon">
                        <img src="${0, (/*@__PURE__*/$parcel$interopDefault($30402a411a8f3b6e$exports))}">
                    </span>
                    <p class="top-feature-card-number">04</p>
                    <p class="top-feature-card-title">Security</p>
                    <p class="top-feature-card-body">Systemized Security Alerts 6+ Safety Alerts</p>
                </div>

                <div class="top-feature-card">
                    <span class="top-feature-card-icon">
                        <img src="${0, (/*@__PURE__*/$parcel$interopDefault($64bf04f7fb3636f8$exports))}">
                    </span>
                    <p class="top-feature-card-number">05</p>
                    <p class="top-feature-card-title">Billing</p>
                    <p class="top-feature-card-body">Automated Bill Generation Pending Bills - Due Alerts</p>
                </div>

                <div class="top-feature-card">
                    <span class="top-feature-card-icon">
                        <img src="${0, (/*@__PURE__*/$parcel$interopDefault($b1480166ba9d3d6d$exports))}">
                    </span>
                    <p class="top-feature-card-number">06</p>
                    <p class="top-feature-card-title">Reports</p>
                    <p class="top-feature-card-body">Vehicle Compliance Drive Compliance Automated Alerts & EHS</p>
                </div>

                <div class="top-feature-card">
                    <span class="top-feature-card-icon">
                        <img src="${0, (/*@__PURE__*/$parcel$interopDefault($a3fddfacbf75fd6c$exports))}">
                    </span>
                    <p class="top-feature-card-number">07</p>
                    <p class="top-feature-card-title">Compliance</p>
                    <p class="top-feature-card-body">Vehicle Compliance Drive Compliance Automated Alerts & EHS</p>
                </div>

                <div class="top-feature-card">
                    <span class="top-feature-card-icon">
                        <img src="${0, (/*@__PURE__*/$parcel$interopDefault($022fa624ac4a6bf9$exports))}">
                    </span>
                    <p class="top-feature-card-number">08</p>
                    <p class="top-feature-card-title">Driver Application</p>
                    <p class="top-feature-card-body">OTP based Login App Notification Trips (Future, History)</p>
                </div>

                <div class="top-feature-card">
                    <span class="top-feature-card-icon">
                        <img src="${0, (/*@__PURE__*/$parcel$interopDefault($75b852fe863fc161$exports))}">
                    </span>
                    <p class="top-feature-card-number">09</p>
                    <p class="top-feature-card-title">Employee Application</p>
                    <p class="top-feature-card-body">Pre & Instant Trip Booking Live Tracking | ETA Safety Features (SOS etc..)</p>
                </div>

                <div class="top-feature-card">
                    <span class="top-feature-card-icon">
                        <img src="${0, (/*@__PURE__*/$parcel$interopDefault($16f5ea11e4f9aee3$exports))}">
                    </span>
                    <p class="top-feature-card-number">10</p>
                    <p class="top-feature-card-title">Decision Makers Podium</p>
                    <p class="top-feature-card-body">Prioritize Dashboards Tracking & Scheduling Both App & Web View</p>
                </div>
            </div>
        </div>

        <div class="landing-main-modules-container">
            <p class="main-module-title"><span>Main</span> Modules</p>
            <div class="main-module-menu-page-container">
                <div class="main-module-side-menu-container">
                    <div class="side-menu-tab active-side-menu-tab" id="dashboard">
                        <div class="side-menu-icon-tab">
                          <svg id="Group_43" data-name="Group 43" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="12.8" viewBox="0 0 16 12.8">
                            <g id="Group_42" data-name="Group 42" clip-path="url(#clip-path)">
                              <path id="Path_258" data-name="Path 258" d="M13,11.6H3a.6.6,0,1,0,0,1.2H13a.6.6,0,1,0,0-1.2M14.4,0H1.6A1.622,1.622,0,0,0,0,1.6V8.8a1.622,1.622,0,0,0,1.6,1.6H14.4A1.622,1.622,0,0,0,16,8.8V1.6A1.623,1.623,0,0,0,14.4,0m.4,8.8a.385.385,0,0,1-.369.4H1.6a.385.385,0,0,1-.4-.369c0-.01,0-.021,0-.031V1.6a.385.385,0,0,1,.369-.4H14.4a.385.385,0,0,1,.4.369c0,.01,0,.021,0,.031Z"/>
                            </g>
                          </svg>
                          <p>Dashboard</p>
                        </div>
                        <hr>
                    </div>

                    <div class="side-menu-tab" id="livetracking">
                        <div class="side-menu-icon-tab">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                            <path id="Path_20436" data-name="Path 20436" d="M6.313-3.219l1.469-1.5a.754.754,0,0,0,0-1.062.754.754,0,0,0-1.062,0L5.25-4.281l-3-3A.872.872,0,0,0,1.656-7.5a.681.681,0,0,0-.531.313A5.618,5.618,0,0,0,0-3.781,5.769,5.769,0,0,0,1.688.313,5.769,5.769,0,0,0,5.781,2,5.618,5.618,0,0,0,9.188.875.681.681,0,0,0,9.5.344.713.713,0,0,0,9.281-.25ZM5.781.5A4.224,4.224,0,0,1,2.75-.75,4.224,4.224,0,0,1,1.5-3.781a4.125,4.125,0,0,1,.375-1.75L7.531.125A4.125,4.125,0,0,1,5.781.5ZM6.75-14a.747.747,0,0,0-.75.75.747.747,0,0,0,.75.75,7.779,7.779,0,0,1,3.906,1.063,7.737,7.737,0,0,1,2.781,2.781A7.779,7.779,0,0,1,14.5-4.75a.747.747,0,0,0,.75.75A.747.747,0,0,0,16-4.75a9.2,9.2,0,0,0-1.25-4.656,9.519,9.519,0,0,0-3.344-3.344A9.2,9.2,0,0,0,6.75-14Zm0,3.25A.747.747,0,0,0,6-10a.747.747,0,0,0,.75.75A4.613,4.613,0,0,1,9.938-7.937,4.613,4.613,0,0,1,11.25-4.75.747.747,0,0,0,12-4a.747.747,0,0,0,.75-.75A6.055,6.055,0,0,0,11-9,6.055,6.055,0,0,0,6.75-10.75Z" transform="translate(0 14)" fill="#9e9e9e"/>
                          </svg>                      
                          <p>Live Tracking</p>
                        </div>
                        <hr>
                    </div>

                    <div class="side-menu-tab" id="drivermanagement">
                        <div class="side-menu-icon-tab">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16">
                              <path id="Path_20437" data-name="Path 20437" d="M2.469-10.812v1.375a10.835,10.835,0,0,0,4.5.938,11.136,11.136,0,0,0,4.563-.937v-1.375l.688-.687a.723.723,0,0,0,.219-.531.751.751,0,0,0-.594-.75L7.219-13.969a1.016,1.016,0,0,0-.5,0L2.094-12.781a.793.793,0,0,0-.562.75.849.849,0,0,0,.25.531ZM7-5.5a2.422,2.422,0,0,1-1.656-.656A2.516,2.516,0,0,1,4.531-7.75Q3.75-7.906,3-8.125V-8A4.035,4.035,0,0,0,4.156-5.156,3.925,3.925,0,0,0,6.969-4,3.925,3.925,0,0,0,9.781-5.156,4.035,4.035,0,0,0,10.938-8v-.125a11.57,11.57,0,0,1-1.469.375,2.516,2.516,0,0,1-.812,1.594A2.422,2.422,0,0,1,7-5.5Zm3,2.531L7.906.5,7.5-1.25,8.5-3h-3l1,1.75L6.094.5,4-2.969a4.214,4.214,0,0,0-2.844,1.25A4.072,4.072,0,0,0,0,1.156.827.827,0,0,0,.844,2H13.156A.827.827,0,0,0,14,1.156a4.012,4.012,0,0,0-1.187-2.875A4.1,4.1,0,0,0,10-2.969ZM1.594.5A2.635,2.635,0,0,1,3.25-1.344L4.344.5ZM9.656.5,10.75-1.344A2.636,2.636,0,0,1,12.406.5Z" transform="translate(0 14)" fill="#9e9e9e"/>
                            </svg>                  
                            <p>Driver Management</p>
                        </div>
                        <hr>
                    </div>

                    <div class="side-menu-tab" id="vehiclemanagement">
                        <div class="side-menu-icon-tab">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                              <path id="Path_20440" data-name="Path 20440" d="M3.5-5a.973.973,0,0,0-.719.281A.973.973,0,0,0,2.5-4a.973.973,0,0,0,.281.719A.973.973,0,0,0,3.5-3a.973.973,0,0,0,.719-.281A.973.973,0,0,0,4.5-4a.973.973,0,0,0-.281-.719A.973.973,0,0,0,3.5-5Zm9,0a.973.973,0,0,0-.719.281A.973.973,0,0,0,11.5-4a.973.973,0,0,0,.281.719A.973.973,0,0,0,12.5-3a.973.973,0,0,0,.719-.281A.973.973,0,0,0,13.5-4a.973.973,0,0,0-.281-.719A.973.973,0,0,0,12.5-5Zm1.969-2.094-1.281-3.187A2.712,2.712,0,0,0,11-11.969V-13a.973.973,0,0,0-.281-.719A.973.973,0,0,0,10-14H6a.973.973,0,0,0-.719.281A.973.973,0,0,0,5-13v1.031a2.712,2.712,0,0,0-2.187,1.688L1.531-7.094A2.82,2.82,0,0,0,.438-6.031,2.793,2.793,0,0,0,0-4.5V1A.963.963,0,0,0,1,2,.963.963,0,0,0,2,1V-.5H14V1a1,1,0,1,0,2,0V-4.5a2.793,2.793,0,0,0-.437-1.531A2.82,2.82,0,0,0,14.469-7.094ZM4.188-9.719A1.242,1.242,0,0,1,5.344-10.5h5.313a1.242,1.242,0,0,1,1.156.781L12.688-7.5H3.313ZM14.5-2H1.5V-4.5a1.631,1.631,0,0,1,.438-1.062A1.631,1.631,0,0,1,3-6h9.969a1.668,1.668,0,0,1,1.094.438A1.447,1.447,0,0,1,14.5-4.5Z" transform="translate(0 14)" fill="#9e9e9e"/>
                            </svg>
                            <p>Vehicle Management</p>
                        </div>
                        <hr>
                    </div>

                    <div class="side-menu-tab" id="tripmanagement">
                        <div class="side-menu-icon-tab">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.8" viewBox="0 0 16 12.8">
                              <path id="Path_20444" data-name="Path 20444" d="M3.6-9.2H2.8a.385.385,0,0,0-.4.4V-8a.385.385,0,0,0,.4.4h.8A.385.385,0,0,0,4-8v-.8A.385.385,0,0,0,3.6-9.2Zm0,2.4H2.8a.385.385,0,0,0-.4.4v.8a.385.385,0,0,0,.4.4h.8A.385.385,0,0,0,4-5.6v-.8A.385.385,0,0,0,3.6-6.8Zm1.6-4.8a.385.385,0,0,0-.4.4v.8a.385.385,0,0,0,.4.4H6a.385.385,0,0,0,.4-.4v-.8a.385.385,0,0,0-.4-.4Zm-1.6,0H2.8a.385.385,0,0,0-.4.4v.8a.385.385,0,0,0,.4.4h.8a.385.385,0,0,0,.4-.4v-.8A.385.385,0,0,0,3.6-11.6Zm4-1v1.2a.6.6,0,0,0,.6.6.6.6,0,0,0,.6-.6v-1.2a1.5,1.5,0,0,0-.4-1,1.5,1.5,0,0,0-1-.4h-6a1.5,1.5,0,0,0-1,.4,1.5,1.5,0,0,0-.4,1v10A.6.6,0,0,0,.6-2a.6.6,0,0,0,.6-.6v-10a.215.215,0,0,1,.2-.2h6A.215.215,0,0,1,7.6-12.6ZM6.4-8.7v-.1A.385.385,0,0,0,6-9.2H5.2a.385.385,0,0,0-.4.4V-8a.385.385,0,0,0,.4.4h.75Zm8.65,1.8-.775-1.975A1.834,1.834,0,0,0,13.6-9.7a1.689,1.689,0,0,0-1-.3H9a1.689,1.689,0,0,0-1,.3,1.834,1.834,0,0,0-.675.825L6.55-6.9A2.416,2.416,0,0,0,5.6-5v3a.779.779,0,0,0,.225.575A.779.779,0,0,0,6.4-1.2a.779.779,0,0,0,.575-.225A.779.779,0,0,0,7.2-2v-.8h7.2V-2a.779.779,0,0,0,.225.575A.779.779,0,0,0,15.2-1.2a.779.779,0,0,0,.575-.225A.779.779,0,0,0,16-2V-5A2.416,2.416,0,0,0,15.05-6.9ZM8.45-8.425A.592.592,0,0,1,9-8.8h3.6a.592.592,0,0,1,.55.375L13.575-7.4H8.025ZM14.8-4h-8V-5a1.3,1.3,0,0,1,.35-.85A1.3,1.3,0,0,1,8-6.2h5.6a1.3,1.3,0,0,1,.85.35A1.3,1.3,0,0,1,14.8-5ZM13.2-5.6a.6.6,0,0,0-.6.6.6.6,0,0,0,.6.6.6.6,0,0,0,.6-.6A.6.6,0,0,0,13.2-5.6Zm-4.8,0a.6.6,0,0,0-.6.6.6.6,0,0,0,.6.6A.6.6,0,0,0,9-5,.6.6,0,0,0,8.4-5.6Z" transform="translate(0 14)" fill="#9e9e9e"/>
                            </svg>
                            <p>Trip Management</p>
                        </div>
                        <hr>
                    </div>

                    <div class="side-menu-tab" id="operatormanagement">
                        <div class="side-menu-icon-tab">
                            <svg id="Group_45" data-name="Group 45" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="12.8" viewBox="0 0 16 12.8">
                              <defs>
                                <clipPath id="clip-path">
                                  <rect id="Rectangle_425" data-name="Rectangle 425" width="16" height="12.8" transform="translate(0 0)" fill="#9e9e9e"/>
                                </clipPath>
                              </defs>
                              <g id="Group_44" data-name="Group 44" transform="translate(0 0)" clip-path="url(#clip-path)">
                                <path id="Path_20462" data-name="Path 20462" d="M2.2,5a.6.6,0,0,0,.6.6h0A.6.6,0,0,0,3.4,5V5a.6.6,0,0,0-.6-.6h0a.6.6,0,0,0-.6.6V5M6.125,6H1.2V5a1.306,1.306,0,0,1,.35-.85A1.307,1.307,0,0,1,2.4,3.8h4.95A2.633,2.633,0,0,1,9,3.2h.55a.075.075,0,0,1-.025-.05A.279.279,0,0,0,9.45,3.1L8.675,1.126A1.832,1.832,0,0,0,8,.3,1.69,1.69,0,0,0,7,0H3.4a1.689,1.689,0,0,0-1,.3,1.833,1.833,0,0,0-.675.825L.95,3.1A2.415,2.415,0,0,0,0,5V8a.77.77,0,0,0,.8.8A.77.77,0,0,0,1.6,8V7.2H5.375a2.338,2.338,0,0,1,.5-.575ZM2.851,1.576A.592.592,0,0,1,3.4,1.2H7a.592.592,0,0,1,.55.375L7.975,2.6H2.425ZM8.4,8.4a.6.6,0,0,0-.6.6V9a.6.6,0,0,0,.595.6h0A.6.6,0,0,0,9,9V9a.6.6,0,0,0-.595-.6H8.4m4.8,0a.6.6,0,0,0-.6.6V9a.6.6,0,0,0,.6.6h0a.6.6,0,0,0,.6-.6V9a.6.6,0,0,0-.6-.6h0m1.85-1.3-.775-1.975A1.833,1.833,0,0,0,13.6,4.3a1.691,1.691,0,0,0-1-.3H9a1.691,1.691,0,0,0-1,.3,1.833,1.833,0,0,0-.675.825L6.551,7.1A2.416,2.416,0,0,0,5.6,9v3a.8.8,0,1,0,1.6,0v-.8h7.2V12A.8.8,0,1,0,16,12V9a2.417,2.417,0,0,0-.95-1.9M8.45,5.575A.593.593,0,0,1,9,5.2h3.6a.592.592,0,0,1,.55.375L13.575,6.6H8.025ZM14.8,10h-8V9A1.2,1.2,0,0,1,8,7.8h5.6A1.2,1.2,0,0,1,14.8,9Z" transform="translate(0 0)" fill="#9e9e9e"/>
                              </g>
                            </svg>
                            <p>Operator Management</p>
                        </div>
                        <hr>
                    </div>

                    <div class="side-menu-tab" id="vendormanagement">
                        <div class="side-menu-icon-tab">
                            <svg id="Group_47" data-name="Group 47" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="12.8" viewBox="0 0 16 12.8">
                              <defs>
                                <clipPath id="clip-path">
                                  <rect id="Rectangle_426" data-name="Rectangle 426" width="16" height="12.8" fill="#9e9e9e"/>
                                </clipPath>
                              </defs>
                              <g id="Group_46" data-name="Group 46" transform="translate(0 0)" clip-path="url(#clip-path)">
                                <path id="Path_20463" data-name="Path 20463" d="M5.6,8.4a.6.6,0,0,0-.6.6V9a.6.6,0,0,0,.6.6h0A.6.6,0,0,0,6.2,9V9a.6.6,0,0,0-.6-.6h0m4.8,0a.6.6,0,0,0-.6.6V9a.6.6,0,0,0,.6.6h0A.6.6,0,0,0,11,9V9a.6.6,0,0,0-.6-.6h0m1.85-1.3-.775-1.975A1.833,1.833,0,0,0,10.8,4.3a1.689,1.689,0,0,0-1-.3H6.2a1.689,1.689,0,0,0-1,.3,1.833,1.833,0,0,0-.675.825L3.75,7.1A2.415,2.415,0,0,0,2.8,9v3a.77.77,0,0,0,.74.8H3.6a.77.77,0,0,0,.8-.74c0-.02,0-.04,0-.06v-.8h7.2V12a.8.8,0,1,0,1.6,0V9a2.416,2.416,0,0,0-.95-1.9M5.65,5.575A.592.592,0,0,1,6.2,5.2H9.8a.591.591,0,0,1,.55.375L10.774,6.6H5.224ZM12,10H4V9a1.3,1.3,0,0,1,.35-.85A1.3,1.3,0,0,1,5.2,7.8h5.6A1.2,1.2,0,0,1,12,9Zm4-5.4a.56.56,0,0,0-.325-.525L8.3.075A.67.67,0,0,0,8,0a.574.574,0,0,0-.3.075l-7.375,4A.56.56,0,0,0,0,4.6a.587.587,0,0,0,.6.575h0A.525.525,0,0,0,.875,5.1L8,1.275,15.124,5.1a.4.4,0,0,0,.25.1q.6-.075.625-.6" transform="translate(0 0)" fill="#9e9e9e"/>
                              </g>
                            </svg>
                            <p>Vendor Management</p>
                        </div>
                        <hr>
                    </div>

                    <div class="side-menu-tab" id="clientmanagement">
                        <div class="side-menu-icon-tab">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.8" viewBox="0 0 16 12.8">
                              <path id="Path_20447" data-name="Path 20447" d="M8-6a2.562,2.562,0,0,0,1.825-.75,2.651,2.651,0,0,0,.75-1.85,2.651,2.651,0,0,0-.75-1.85A2.621,2.621,0,0,0,8-11.2a2.562,2.562,0,0,0-1.825.75,2.651,2.651,0,0,0-.75,1.85A2.559,2.559,0,0,0,6.15-6.75,2.651,2.651,0,0,0,8-6Zm0-4a1.407,1.407,0,0,1,.975.4,1.447,1.447,0,0,1,.425,1,1.447,1.447,0,0,1-.425,1A1.407,1.407,0,0,1,8-7.2a1.5,1.5,0,0,1-1-.4,1.5,1.5,0,0,1-.4-1,1.5,1.5,0,0,1,.4-1A1.5,1.5,0,0,1,8-10Zm4.8,0a2.075,2.075,0,0,0,1.425-.575A2.075,2.075,0,0,0,14.8-12a2.075,2.075,0,0,0-.575-1.425A2.075,2.075,0,0,0,12.8-14a2.075,2.075,0,0,0-1.425.575A2.075,2.075,0,0,0,10.8-12a2.075,2.075,0,0,0,.575,1.425A2.075,2.075,0,0,0,12.8-10ZM9.25-5.2H6.75a3.579,3.579,0,0,0-2.5.975A3.283,3.283,0,0,0,3.2-1.875a.6.6,0,0,0,.2.475.678.678,0,0,0,.5.2h8.2a.678.678,0,0,0,.5-.2.6.6,0,0,0,.2-.475,3.283,3.283,0,0,0-1.05-2.35A3.579,3.579,0,0,0,9.25-5.2ZM4.45-2.4a2.28,2.28,0,0,1,.825-1.15A2.665,2.665,0,0,1,6.725-4H9.25a2.665,2.665,0,0,1,1.45.45,2.1,2.1,0,0,1,.825,1.15ZM13.8-9.2H12.25a2.088,2.088,0,0,0-.9.2.278.278,0,0,0,.025.125A1.4,1.4,0,0,1,11.4-8.6a3.359,3.359,0,0,1-.825,2.2H15.55A.482.482,0,0,0,16-6.875a2.436,2.436,0,0,0-.65-1.65A2.149,2.149,0,0,0,13.8-9.2Zm-9.2.6a1.822,1.822,0,0,1,.025-.3A.222.222,0,0,1,4.65-9a2.088,2.088,0,0,0-.9-.2H2.2a2.149,2.149,0,0,0-1.55.675A2.436,2.436,0,0,0,0-6.875.482.482,0,0,0,.45-6.4H5.425A3.359,3.359,0,0,1,4.6-8.6ZM3.2-10a2.075,2.075,0,0,0,1.425-.575A2.075,2.075,0,0,0,5.2-12a2.075,2.075,0,0,0-.575-1.425A2.075,2.075,0,0,0,3.2-14a2.075,2.075,0,0,0-1.425.575A2.075,2.075,0,0,0,1.2-12a2.075,2.075,0,0,0,.575,1.425A2.075,2.075,0,0,0,3.2-10Z" transform="translate(0 14)" fill="#9e9e9e"/>
                            </svg>
                            <p>Client Management</p>
                        </div>
                        <hr>
                    </div>

                    <div class="side-menu-tab" id="paymentmanagement">
                        <div class="side-menu-icon-tab">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12.012" height="16" viewBox="0 0 12.012 16">
                              <path id="Path_20450" data-name="Path 20450" d="M12.574-13.937a.734.734,0,0,0-.813.125l-1.22,1.032-1-1a.722.722,0,0,0-.97-.063L7.006-12.686,5.442-13.844a.722.722,0,0,0-.97.063l-1,1-1.22-1.032a.734.734,0,0,0-.813-.125A.794.794,0,0,0,1-13.249V1.234a.794.794,0,0,0,.438.688A.734.734,0,0,0,2.251,1.8L3.471.764l1,1a.722.722,0,0,0,.97.063L7.006.671,8.57,1.828a.722.722,0,0,0,.97-.063l1-1L11.761,1.8a.747.747,0,0,0,.5.188.837.837,0,0,0,.313-.063.746.746,0,0,0,.438-.688V-13.249A.794.794,0,0,0,12.574-13.937ZM11.51-.362,11.01-.8a.779.779,0,0,0-1.032.031L8.945.264,7.444-.831a.83.83,0,0,0-.438-.188.83.83,0,0,0-.438.188L5.066.264,4.034-.768A.779.779,0,0,0,3-.8l-.5.438V-11.623l.5.438a.779.779,0,0,0,1.032-.031l1.032-1.032,1.5,1.095a.691.691,0,0,0,.876,0l1.5-1.095,1.032,1.032a.779.779,0,0,0,1.032.031l.5-.438ZM9.759-9H4.253q-.469.063-.5.469a.469.469,0,0,0,.5.469H9.759a.469.469,0,0,0,.5-.469Q10.228-8.933,9.759-9Zm0,4.974H4.253q-.469.063-.5.469a.469.469,0,0,0,.5.469H9.759a.469.469,0,0,0,.5-.469Q10.228-3.959,9.759-4.021Zm0-2.471H4.253q-.469.063-.5.469a.469.469,0,0,0,.5.469H9.759a.469.469,0,0,0,.5-.469Q10.228-6.43,9.759-6.493Z" transform="translate(-1 14.008)" fill="#9e9e9e"/>
                            </svg>
                            <p>Payment Management</p>
                        </div>
                        <hr>
                    </div>

                </div>

                <div class="main-module-main-page-container">
                    <img src="${0, (/*@__PURE__*/$parcel$interopDefault($21f54033038d7836$exports))}" class="module-screenshot-icon">
                </div>
            </div>
        </div>

        <div class="lanidng-cloud-solution-container">
            <p class="cloud-solution-title"><span>Cloud</span> Solution</p>
            <div class="cloud-card-container">
                <div class="cloud-card-tab">
                    <img src="${0, (/*@__PURE__*/$parcel$interopDefault($bc210e678f5a2281$exports))}">
                    <p>Secure Data Storage</p>
                </div>

                <div class="cloud-card-tab">
                    <img src="${0, (/*@__PURE__*/$parcel$interopDefault($f9f4a74791b36a2a$exports))}">
                    <p>Scalability and Flexibility</p>
                </div>

                <div class="cloud-card-tab">
                    <img src="${0, (/*@__PURE__*/$parcel$interopDefault($28326261748b20ba$exports))}">
                    <p>Accessibility from anywhere</p>
                </div>

                <div class="cloud-card-tab">
                    <img src="${0, (/*@__PURE__*/$parcel$interopDefault($3446c178285ad0f6$exports))}">
                    <p>Integration with other platforms</p>
                </div>
            </div>
        </div>

        <div class="landing-application-container">
            <div class="application-container-parent-tab">
                <div class="application-container-tab">
                    <p class="driver-application-tab active-tab-button">Driver Application</p>
                    <p class="employee-application-tab">Employee Application</p>
                </div>
            </div>
            
            <div class="application-body-tab driver-application">
                <div class="application-body-left-tab">
                    <div class="application-features active-application" id="homeDriver">
                        <p class="application-body-title">Home</p>
                        <p class="application-body-body">VM Routes Drivers is more than just an app; it's a commitment to providing exceptional transportation services. We aim to elevate your driving experience while ensuring efficient and safe commutes for passengers.</p>
                    </div>
                    <div class="application-features" id="instantRideDriver">
                        <p class="application-body-title">Instant Ride</p>
                        <p class="application-body-body">Need book an instant ride now? No problem ! with VM Routes App , You can book an instant trip as long as you plan it at least 6 hours ahead for pickup location and 4 hours for drop location.</p>
                    </div>
                    <div class="application-features" id="assignedTripsDriver">
                        <p class="application-body-title">Assigned Trips</p>
                        <p class="application-body-body">Driver can check his assigned trips through app.</p>
                    </div>
                </div>

                <img src="${0, (/*@__PURE__*/$parcel$interopDefault($796e53c0c1c8bbed$exports))}" class="application-phone-icon">

                <div class="application-body-right-tab">
                    <div class="application-features" id="tripHistoryDriver">
                        <p class="application-body-title">Trip History</p>
                        <p class="application-body-body">Driver can check his last one month trip history.</p>
                    </div>
                    <div class="application-features" id="myAccountsDriver">
                        <p class="application-body-title">My Accounts</p>
                        <p class="application-body-body">Driver can update details in the my account page.</p>
                    </div>
                    <div class="application-features" id="noShowDriver">
                        <p class="application-body-title">No Show</p>
                        <p class="application-body-body">When employee fails to inform driver about his absence it falls under no show.</p>
                    </div>
                </div>
            </div>

            <div class="application-body-tab employee-application">
                <div class="application-body-left-tab">
                    <div class="application-features active-application" id="homeEmployee">
                        <p class="application-body-title">Home</p>
                        <p class="application-body-body">Employee Transportation Service is tailor made to ensure you reach your workplace comfortably and on time.</p>
                    </div>
                    <div class="application-features" id="createTripsEmployee">
                        <p class="application-body-title">Create Trips</p>
                        <p class="application-body-body">Employee can be able to manually create their trip schedule or any changes present/absent.</p>
                    </div>
                    <div class="application-features" id="upcomingTripsEmployee">
                        <p class="application-body-title">Upcoming Trips</p>
                        <p class="application-body-body">Employee can check his upcoming trips with timing.</p>
                    </div>
                </div>

                <img src="${0, (/*@__PURE__*/$parcel$interopDefault($59ab84433bd2ed88$exports))}" class="application-phone-icon">

                <div class="application-body-right-tab">
                    <div class="application-features" id="tripHistoryEmployee">
                        <p class="application-body-title">Trip History</p>
                        <p class="application-body-body">Keep track of your past rides, receipts, and routes for reference and expense tracking.</p>
                    </div>
                    <div class="application-features" id="absentRecordEmployee">
                        <p class="application-body-title">Absent Record</p>
                        <p class="application-body-body">Oops, Marked Absent ! VM Routes App Keeps it Simple. Mark the absent days on your following trip schedule days.</p>
                    </div>
                    <div class="application-features" id="settingsEmployee">
                        <p class="application-body-title">Settings</p>
                        <p class="application-body-body">Employee can set his theme ,can check privacy policy what do's and dont's.</p>
                    </div>
                </div>
            </div>

        </div>

        <div class="landing-footer-container">
            <div class="landing-footer-details-tab">

                <div class="footer-company-details-tab">
                    <img src="${0, (/*@__PURE__*/$parcel$interopDefault($5PfYl))}">
                    <p class="footer-tab-body"><img src="${0, (/*@__PURE__*/$parcel$interopDefault($eZpnS))}"> #8/25, 2nd & 3rd Floor, Kambar Street, Alandur, Chennai - 600 016</p>
                    <p class="footer-tab-body"><img src="${0, (/*@__PURE__*/$parcel$interopDefault($8JYd6))}"> +91 90921 90321</p>
                    <p class="footer-tab-body"><img src="${0, (/*@__PURE__*/$parcel$interopDefault($3e7ho))}"> reachus@virtualmaze.co.in</p>
                </div>
    
                <div class="footer-legal-tab">
                    <p class="footer-tab-title">Legal</p>
                    <p class="footer-tab-body"><a href="${(0, $DkdI3.default).production}/terms-and-conditions" target="_blank">Terms and Conditions</a></p>
                    <p class="footer-tab-body"><a href="${(0, $DkdI3.default).production}/privacy-policy" target="_blank">Privacy Policy</a></p>
                    <p class="footer-tab-body"><a href="${(0, $DkdI3.default).production}/cookie-policy" target="_blank">Cookie Policy</a></p>
                </div>
    
                <div class="footer-help-tab">
                    <p class="footer-tab-title">Help</p>
                    <p class="footer-tab-body contact-us-menu-button">Contact Us</p>
                    <div class="footer-icons-container">
                        <a href="https://www.linkedin.com/company/99296180/admin/feed/posts/" target="_blank"><img src="${0, (/*@__PURE__*/$parcel$interopDefault($47DtA))}"></a>
                        <a href="https://www.facebook.com/vmroutes" target="_blank"><img src="${0, (/*@__PURE__*/$parcel$interopDefault($KwfgD))}"></a>

                    </div>
                </div>

                <div class="footer-help-tab">
                    <p class="footer-tab-title">Security</p>
                    <div class="footer-icons-container">
                        <img src="${0, (/*@__PURE__*/$parcel$interopDefault($dBUyq))}">
                        <img src="${0, (/*@__PURE__*/$parcel$interopDefault($9o09i))}">
                    </div>
                </div>

            </div>
            
            <p class="copyright-footer">Copyright © 2024 . VirtualMaze Softsys Private Limited</p>
        </div>

    </div>

    <div class="contact-us-page-container" style="display:none;">
        <div class="contact-us-form-container">
            <div class="contact-form-left-container">
                <p class="contact-form-top-text">Do you have more questions about Agency Portal?</p>
                <p class="contact-form-middle-text"><span>Say Hi!</span> and leave us a message</p>
                <p class="contact-form-bottom-text">Our team will contact you as soon as possible</p>

                <form id="contactForm">
                    <div class="contact-input-container">
                    <label for="fullName">Full Name:</label>
                    <input type="text" id="fullName" name="fullName" placeholder="Ramesh" class="contact-input" required>
                    </div>
                
                    <div class="contact-input-container">
                    <label for="email">Email Address:</label>
                    <input type="email" id="email" name="email" placeholder="ezioauditore@gmail.com" class="contact-input" required>
                    </div>
    
                    <div class="contact-input-container">
                    <label for="phone">Mobile Number:</label>
                    <input type="tel" id="phone" name="phone" placeholder="98765 43210" class="contact-input" required>
                    </div>
                
                    <div class="contact-input-container">
                    <label for="subject">Subject:</label>
                    <input type="text" id="subject" name="subject" placeholder="Enquiry on software" class="contact-input" required>
                    </div>
                
                    <div class="contact-input-container">
                    <label for="message">Message:</label>
                    <input type="text" id="message" name="message" placeholder="Write a message" class="contact-input" required>
                    </div>

                    <button class="contact-submit-button">Submit</button>
                </form>
            </div>
            <img src="${0, (/*@__PURE__*/$parcel$interopDefault($25c9V))}" class="contact-side-icon">
        </div>

        <div class="contact-information-container">
            <p class="contact-information-title">CONTACT INFORMATION</p>
            <div class="contact-details-container">
                <p class="footer-tab-body"><img src="${0, (/*@__PURE__*/$parcel$interopDefault($k5z4A))}"> #8/25, 2nd & 3rd Floor, Kambar Street, Alandur, Chennai - 600 016</p>
                <p class="footer-tab-body"><img src="${0, (/*@__PURE__*/$parcel$interopDefault($flovY))}"> reachus@virtualmaze.co.in</p>
                <p class="footer-tab-body"><img src="${0, (/*@__PURE__*/$parcel$interopDefault($5AxGM))}"> +91 90921 90321</p>
            </div>
        </div>

        <iframe style="width: 100%;" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15549.788523735537!2d80.19645827526911!3d13.007173759492792!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267c99154969b%3A0x1892d69b6e39e850!2sVirtualMaze!5e0!3m2!1sen!2sin!4v1702966608642!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>

    <div class="contact-submit-success-parent-container" style="display: none;">
        <div class="contact-submit-success-inner-container">
            <div class="contact-submit-success-container">
                <img src="${0, (/*@__PURE__*/$parcel$interopDefault($bmmz0))}" class="contact-success-icon">
                <p class="contact-thank-you-header">Thank you registering with us.</p>
                <p>Your application has been successfully submitted. Our representative will get in touch with you</p>
                <button class="success-ok-button">Ok</button>
            </div>
        </div>
    </div>
    
</div>
    `;
        let glide = new (0, $e4cadc049684851d$export$2e2bcd8739ae039)(".glide", {
            type: "carousel",
            focusAt: "center",
            autoplay: 3000,
            hoverpause: true,
            bound: true,
            perView: 2,
            breakpoints: {
                1600: {
                    perView: 1
                }
            }
        }).mount();
        return this.container;
    };
    addEvents(container) {
        const handleResize = ()=>{
            const currentWidth = window.innerWidth;
            if (currentWidth >= 1099) {
                const newHeight = container.querySelector(".module-screenshot-icon").clientHeight;
                container.querySelector(".main-module-side-menu-container").style.height = newHeight + "px";
            } else container.querySelector(".main-module-side-menu-container").style.height = "unset";
        };
        window.addEventListener("load", handleResize);
        window.addEventListener("resize", handleResize);
        // const slider = container.querySelector('.landing-genesis-parent');
        // let mouseDown = false;
        // let startX, scrollLeft;
        // const startDragging = (e) => {
        //     mouseDown = true;
        //     startX = e.pageX - slider.offsetLeft;
        //     scrollLeft = slider.scrollLeft;
        // }
        // const stopDragging = () => {
        //     mouseDown = false;
        // }
        // const move = (e) => {
        //     e.preventDefault();
        //     if (!mouseDown) { return; }
        //     const x = e.pageX - slider.offsetLeft;
        //     const scroll = x - startX;
        //     slider.scrollLeft = scrollLeft - scroll;
        // }
        // // Add a single listener for mouse events on the slider
        // slider.addEventListener('mousemove', move, false);
        // slider.addEventListener('mousedown', startDragging, false);
        // slider.addEventListener('mouseup', stopDragging, false);
        // slider.addEventListener('mouseleave', stopDragging, false);
        // // Auto-scroll logic (as before)
        // let autoScrollInterval;
        // const scrollSpeed = 1;
        // let direction = 1;
        // let isVisible = false;
        // let pauseStartTime = 0;
        // const startAutoScroll = () => {
        //     clearInterval(autoScrollInterval);
        //     const animateScroll = (timestamp) => {
        //         if (isVisible) {
        //             if (pauseStartTime === 0) {
        //                 slider.scrollLeft += direction * scrollSpeed;
        //             }
        //             const isAtEnd = slider.scrollLeft >= slider.scrollWidth - slider.clientWidth || slider.scrollLeft <= 0;
        //             if (isAtEnd) {
        //                 if (pauseStartTime === 0) {
        //                     pauseStartTime = timestamp;
        //                 }
        //                 const pauseDuration = timestamp - pauseStartTime;
        //                 if (pauseDuration > 4000) {
        //                     direction *= -1;
        //                     pauseStartTime = 0;
        //                 }
        //             } else {
        //                 pauseStartTime = 0;
        //             }
        //         }
        //         if (isVisible) {
        //             autoScrollInterval = requestAnimationFrame(animateScroll);
        //         }
        //     };
        //     autoScrollInterval = requestAnimationFrame(animateScroll);
        // };
        // const stopAutoScroll = () => {
        //     clearInterval(autoScrollInterval);
        //     pauseStartTime = 0;
        // };
        // const handleVisibility = () => {
        //     const rect = slider.getBoundingClientRect();
        //     isVisible = (
        //         rect.top >= 0 &&
        //         rect.left >= 0 &&
        //         rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        //         rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        //     );
        //     if (!isVisible) {
        //         stopAutoScroll();
        //     }
        // };
        // slider.addEventListener('mouseenter', () => {
        //     stopAutoScroll();
        // });
        // slider.addEventListener('mouseleave', () => {
        //     startAutoScroll();
        // });
        // window.addEventListener('blur', stopAutoScroll);
        // window.addEventListener('scroll', handleVisibility);
        // window.addEventListener('resize', handleVisibility);
        // startAutoScroll();
        // handleVisibility();
        this.moduleMenuSelected = container.querySelector(".active-side-menu-tab");
        let home = container.querySelector("#home-nav");
        let contactNav = container.querySelector("#contact-nav");
        let contacts = container.querySelectorAll(".contact-us-menu-button");
        home.addEventListener("click", ()=>{
            container.querySelector(".contact-us-page-container").style.display = "none";
            container.querySelector(".home-page-container").style.display = "block";
            home.classList.add("navbar-active-link");
            contactNav.classList.remove("navbar-active-link");
        });
        contacts.forEach((contact)=>{
            contact.addEventListener("click", ()=>{
                container.querySelector(".contact-us-page-container").style.display = "block";
                container.querySelector(".home-page-container").style.display = "none";
                home.classList.remove("navbar-active-link");
                contactNav.classList.add("navbar-active-link");
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            });
        });
        document.getElementById("contactForm").addEventListener("submit", async function(event) {
            event.preventDefault();
            const formData = {
                name: container.querySelector("#fullName").value,
                email: container.querySelector("#email").value,
                phone: container.querySelector("#phone").value,
                subject: container.querySelector("#subject").value,
                message: container.querySelector("#message").value
            };
            const url = (0, $dUT0w.default)["proxyUrl"] + `/contactUs`;
            try {
                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(formData)
                });
                const jsonRes = await response.json();
                if (!jsonRes.success) ;
                else {
                    container.querySelector(".contact-submit-success-parent-container").style.display = "flex";
                    document.querySelector(".landing-page-main-container").style.overflow = "hidden";
                    container.querySelector("#fullName").value = "";
                    container.querySelector("#email").value = "";
                    container.querySelector("#phone").value = "";
                    container.querySelector("#subject").value = "";
                    container.querySelector("#message").value = "";
                }
            } catch (err) {
                console.error("Error:", err);
            }
        });
        let success = document.querySelector(".success-ok-button");
        success.addEventListener("click", ()=>{
            container.querySelector(".contact-submit-success-parent-container").style.display = "none";
            document.querySelector(".landing-page-main-container").style.overflow = "unset";
        });
        let moduleMenuTab = container.querySelectorAll(".side-menu-tab");
        moduleMenuTab.forEach((menuTab)=>{
            menuTab.addEventListener("click", ()=>{
                this.moduleMenuSelected && this.moduleMenuSelected.classList.remove("active-side-menu-tab");
                this.moduleMenuSelected = menuTab;
                menuTab.classList.add("active-side-menu-tab");
                let moduleImage = container.querySelector(".module-screenshot-icon");
                if (menuTab.id == "dashboard") moduleImage.src = (0, (/*@__PURE__*/$parcel$interopDefault($21f54033038d7836$exports)));
                else if (menuTab.id == "livetracking") moduleImage.src = (0, (/*@__PURE__*/$parcel$interopDefault($bdd3e294f5e0c8d1$exports)));
                else if (menuTab.id == "clientmanagement") moduleImage.src = (0, (/*@__PURE__*/$parcel$interopDefault($b70333fc00ed3144$exports)));
                else if (menuTab.id == "drivermanagement") moduleImage.src = (0, (/*@__PURE__*/$parcel$interopDefault($0b54781138f0e07e$exports)));
                else if (menuTab.id == "tripmanagement") moduleImage.src = (0, (/*@__PURE__*/$parcel$interopDefault($2f59ba8ab64cba3a$exports)));
                else if (menuTab.id == "paymentmanagement") moduleImage.src = (0, (/*@__PURE__*/$parcel$interopDefault($345999c5a3f0615b$exports)));
                else if (menuTab.id == "operatormanagement") moduleImage.src = (0, (/*@__PURE__*/$parcel$interopDefault($806ba0e73f9a5d90$exports)));
                else if (menuTab.id == "vendormanagement") moduleImage.src = (0, (/*@__PURE__*/$parcel$interopDefault($f80bf49ee85e2d32$exports)));
                else if (menuTab.id == "vehiclemanagement") moduleImage.src = (0, (/*@__PURE__*/$parcel$interopDefault($bdcba894a1075853$exports)));
            });
        });
        let hamburger = container.querySelector(".hamburger-icon");
        let navbar = container.querySelector(".navbar-link-header");
        hamburger.addEventListener("click", ()=>{
            if (hamburger.src.includes((0, (/*@__PURE__*/$parcel$interopDefault($cuiEO))))) {
                hamburger.src = (0, (/*@__PURE__*/$parcel$interopDefault($8NNKi)));
                navbar.classList.add("hamburger-navbar-link-header");
            } else {
                hamburger.src = (0, (/*@__PURE__*/$parcel$interopDefault($cuiEO)));
                navbar.classList.remove("hamburger-navbar-link-header");
            }
        });
        let navbarLink = container.querySelectorAll(".navbar-link");
        navbarLink.forEach((navabarOne)=>{
            navabarOne.addEventListener("click", ()=>{
                navbar.classList.remove("hamburger-navbar-link-header");
                hamburger.src = (0, (/*@__PURE__*/$parcel$interopDefault($cuiEO)));
            });
        });
        let driverAppButton = container.querySelector(".driver-application-tab");
        let employeeAppButton = container.querySelector(".employee-application-tab");
        let driverApplication = container.querySelector(".driver-application");
        let employeeApplication = container.querySelector(".employee-application");
        driverAppButton.addEventListener("click", ()=>{
            driverAppButton.classList.add("active-tab-button");
            employeeAppButton.classList.remove("active-tab-button");
            employeeApplication.style.display = "none";
            driverApplication.style.display = "flex";
            let driverAppTab = container.querySelectorAll(".driver-application .application-features");
            let driverImageTab = container.querySelector(".driver-application .application-phone-icon");
            this.driverCurrentTab = container.querySelector(".driver-application .active-application");
            driverAppTab.forEach((driverTab)=>{
                driverTab.addEventListener("click", ()=>{
                    this.driverCurrentTab && this.driverCurrentTab.classList.remove("active-application");
                    this.driverCurrentTab = driverTab;
                    driverTab.classList.add("active-application");
                    if (driverTab.id == "homeDriver") driverImageTab.src = (0, (/*@__PURE__*/$parcel$interopDefault($796e53c0c1c8bbed$exports)));
                    else if (driverTab.id == "instantRideDriver") driverImageTab.src = (0, (/*@__PURE__*/$parcel$interopDefault($edf69615f0452b2d$exports)));
                    else if (driverTab.id == "assignedTripsDriver") driverImageTab.src = (0, (/*@__PURE__*/$parcel$interopDefault($687063693d14a4c7$exports)));
                    else if (driverTab.id == "tripHistoryDriver") driverImageTab.src = (0, (/*@__PURE__*/$parcel$interopDefault($da1e4ef46e934019$exports)));
                    else if (driverTab.id == "myAccountsDriver") driverImageTab.src = (0, (/*@__PURE__*/$parcel$interopDefault($d23db20b988491a9$exports)));
                    else if (driverTab.id == "noShowDriver") driverImageTab.src = (0, (/*@__PURE__*/$parcel$interopDefault($aa00ee01ce7121c3$exports)));
                });
            });
        });
        driverAppButton.click();
        employeeAppButton.addEventListener("click", ()=>{
            employeeAppButton.classList.add("active-tab-button");
            driverAppButton.classList.remove("active-tab-button");
            driverApplication.style.display = "none";
            employeeApplication.style.display = "flex";
            let employeeAppTab = container.querySelectorAll(".employee-application .application-features");
            let employeeImageTab = container.querySelector(".employee-application .application-phone-icon");
            this.employeeCurrentTab = container.querySelector(".employee-application .active-application");
            employeeAppTab.forEach((employeeTab)=>{
                employeeTab.addEventListener("click", ()=>{
                    this.employeeCurrentTab && this.employeeCurrentTab.classList.remove("active-application");
                    this.employeeCurrentTab = employeeTab;
                    employeeTab.classList.add("active-application");
                    if (employeeTab.id == "homeEmployee") employeeImageTab.src = (0, (/*@__PURE__*/$parcel$interopDefault($59ab84433bd2ed88$exports)));
                    else if (employeeTab.id == "createTripsEmployee") employeeImageTab.src = (0, (/*@__PURE__*/$parcel$interopDefault($b36500abb531d545$exports)));
                    else if (employeeTab.id == "upcomingTripsEmployee") employeeImageTab.src = (0, (/*@__PURE__*/$parcel$interopDefault($431456f3100abfe4$exports)));
                    else if (employeeTab.id == "tripHistoryEmployee") employeeImageTab.src = (0, (/*@__PURE__*/$parcel$interopDefault($917b7e540a6c689c$exports)));
                    else if (employeeTab.id == "absentRecordEmployee") employeeImageTab.src = (0, (/*@__PURE__*/$parcel$interopDefault($a1492487b6416c40$exports)));
                    else if (employeeTab.id == "settingsEmployee") employeeImageTab.src = (0, (/*@__PURE__*/$parcel$interopDefault($18814ebf0ccd3ba8$exports)));
                });
            });
        });
    }
}
var $a51c7973921171ed$export$2e2bcd8739ae039 = $a51c7973921171ed$var$LandingPage;


new (0, $a51c7973921171ed$export$2e2bcd8739ae039)({});


//# sourceMappingURL=landingPage.754a515b.js.map
